<template>
  <div v-if="isShow" id="alarmCenter">
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div
      style="
        position: absolute;
        right: 0px;
        z-index: 1;
        line-height: 30px;
        font-size: 15px;
      "
    >
      <Poptip
        v-model="isHelp"
        placement="right"
        style="font-size: 18px; cursor: pointer"
      >
        <Icon type="ios-help-circle-outline" title="帮助" />
        <div class="api" slot="content" style="background: #ccc">
          <img :src="imgHelp" alt="" :style="imgStyle" />
          <Icon
            type="md-close-circle"
            style="color: red; position: absolute; font-size: 21px"
            @click="closeHelp"
            title="关闭"
          />
        </div>
      </Poptip>
      <Icon title="退出" class="exit" type="md-exit" @click="tologin" />
      <!-- //<Button slot="append" icon="ios-contact" @click="queryDesc"></Button> -->
      <!-- <Button type="success" long @click="tologin">更换登录类型</Button> -->
    </div>
    <!--树节点-->
    <div :style="treeStyleNode">
      <Split v-model="split1" min="200" max="1000">
        <div slot="left" style="100%">
          <div class="treeNodeStyle">
            <Icon title="用户" type="md-contact" />
            {{ loginName }}
            <!--img :src="imgSrc" alt="" style="width:135px;height:31px">-->
            <Poptip
              v-model="isTreeHelp"
              placement="right"
              style="
                font-size: 18px;
                cursor: pointer;
                position: absolute;
                right: 5%;
              "
            >
              <Icon type="ios-help-circle-outline" title="帮助" />
              <div class="api" slot="content" style="background: #ccc">
                <img :src="imgTreeHelp" alt="" :style="imgStyle" />
                <Icon
                  type="md-close-circle"
                  style="color: red; position: absolute; font-size: 21px"
                  @click="closeHelp"
                  title="关闭"
                />
              </div>
            </Poptip>
          </div>

          <Tree
            :data="dataTree"
            :render="renderContent"
            class="treeStyle"
          ></Tree>
          <Dropdown
            transfer
            ref="localMenu"
            class="isShow"
            trigger="click"
            placement="right-start"
          >
            <DropdownMenu slot="list" class="minWidth">
              <DropdownItem @click.native="modal1 = true" style="color: #2d8cf0"
                >新增节点
              </DropdownItem>
              <DropdownItem
                v-show="isAble"
                @click.native="onDelNode"
                style="color: #2d8cf0"
                >删除节点
              </DropdownItem>
              <DropdownItem
                v-show="isAble"
                @click.native="noRename"
                style="color: #2d8cf0"
                >重命名
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div slot="right" style="width: 100%; height: 100%">
          <!-- 测点悬浮按钮 -->
          <Button
            title="测点添加"
            icon="md-add"
            type="success"
            size="large"
            @click="spotAddButton"
            v-show="addButton == 'tag'"
            style="z-index: 80; position: absolute; right: 15px; bottom: 0px"
            shape="circle"
          ></Button>
          <div
            @click="queryButtonSpot('tag')"
            v-show="addButton == 'tag'"
            title="搜索"
            style="
              z-index: 80;
              position: absolute;
              right: 0px;
              top: 45px;
              font-size: 25px;
              cursor: pointer;
            "
          >
            <Icon type="md-search" />
          </div>
          <p
            style="z-index: 800; position: absolute; right: 0px; top: 50px"
            v-show="isQuery"
            class="qStyle"
          >
            <Input
              placeholder="请输入查询信息"
              style="width: 100%; border: #2b85e4"
              class="active"
              v-model="searchText"
            >
              <Icon
                type="ios-search"
                slot="suffix"
                color="blue"
                @click="querySpot1"
              />
            </Input>
          </p>

          <!-- 模型添加点按钮 -->
          <Button
            title="模型添加"
            icon="md-add"
            type="success"
            size="large"
            @click="addNodes"
            v-show="addButton == 'model'"
            style="z-index: 80; position: absolute; right: 15px; bottom: 0px"
            shape="circle"
          ></Button>
          <div
            @click="queryButtonSpot('model')"
            v-show="addButton == 'model'"
            title="搜索"
            style="
              z-index: 80;
              position: absolute;
              right: 0px;
              top: 45px;
              font-size: 25px;
              cursor: pointer;
            "
          >
            <Icon type="md-search" />
          </div>

          <!-- 规则添加点按钮 -->
          <Button
            title="规则添加"
            icon="md-add"
            type="success"
            size="large"
            @click="addRule"
            v-show="addButton == 'rule'"
            style="z-index: 80; position: absolute; right: 15px; bottom: 0px"
            shape="circle"
          ></Button>
          <Tabs type="card" @on-click="onTabs">
            <Tab-pane label="测点">
              <div>
                <div class="tableStyle">
                  <Table
                    @on-row-click="onTable"
                    :height="tableHeight"
                    highlight-row
                    ref="selection"
                    :columns="historyColumns"
                    :data="historyData"
                  >
                    <template slot-scope="{ row, index }" slot="action">
                      <Button
                        type="primary"
                        size="small"
                        style="margin-right: 5px"
                        @click="show(index)"
                        >View
                      </Button>
                      <Button type="error" size="small" @click="remove(index)"
                        >Delete
                      </Button>
                      <Button type="error" size="small" @click="remove(index)"
                        >Delete
                      </Button>
                    </template>
                  </Table>
                  <p
                    class="buttonList"
                    style="padding-left: 10px; position: relative; width: 100%"
                  >
                    <Button
                      style="margin: 2px"
                      type="success"
                      @click="exportPointExcel"
                      >导出测点
                    </Button>
                  </p>
                  <Page
                    :total="dataCount"
                    :current="dataCountCurrent"
                    :page-size="pageSize"
                    show-total
                    @on-change="changepage"
                  ></Page>
                </div>
                <div class="buttonStyle">
                  <Modal v-model="modal1" title="新增节点" @on-ok="onAddNode">
                    节点名称：<Input
                      v-model="newNode"
                      placeholder=""
                      style="width: 80%; padding: 1px"
                    />
                  </Modal>
                  <Modal v-model="modal3" title="节点重名" @on-ok="onRename">
                    节点名称：<Input
                      placeholder="重命名..."
                      v-model="nodeRename"
                      style="width: 80%; padding: 1px"
                    />
                  </Modal>
                  <Modal
                    v-model="modal4"
                    title="新增测点"
                    width="650"
                    @on-ok="onAddSpot"
                  >
                    <div style="margin-bottom: 5px">
                      <b style="font-size: 15px; padding-left: 10px"
                        >测点名称：</b
                      >
                      <Input
                        placeholder="输入点名称模糊查询"
                        v-model="spotName"
                        style="width: 33%; padding: 1px; display: inline-table"
                      >
                        <Button
                          slot="append"
                          icon="ios-search"
                          @click="querySpot"
                        ></Button>
                      </Input>
                      <b style="font-size: 15px; padding-left: 10px"
                        >测点描述：</b
                      >
                      <Input
                        placeholder="输入名点描述糊查询"
                        v-model="descName"
                        style="width: 33%; padding: 1px; display: inline-table"
                      >
                        <Button
                          slot="append"
                          icon="ios-search"
                          @click="queryDesc"
                        ></Button>
                      </Input>
                    </div>
                    <Scroll :on-reach-bottom="handleReachBottom">
                      <Table
                        @on-select="onSelect"
                        highlight-row
                        ref="selectionSpot"
                        :columns="additionsTable"
                        :data="columnsData"
                      ></Table>
                      <Button
                        class="loadMoreStyle"
                        size="small"
                        type="success"
                        v-show="isLoadMore"
                        :loading="loading"
                        @click="loadMore"
                        >加载更多...
                      </Button>
                    </Scroll>
                  </Modal>
                </div>
              </div>
            </Tab-pane>
            <Tab-pane label="模型">
              <div class="labels">
                <div>
                  <div class="tableStyle" id="cs">
                    <Table
                      :height="tableHeight"
                      highlight-row
                      ref="selection"
                      :columns="modelColumns"
                      :data="modelData"
                    >
                      <template slot-scope="{ row, index }" slot="action">
                        <Button
                          type="primary"
                          size="small"
                          style="margin-right: 5px"
                          @click="show(index)"
                          >View
                        </Button>
                        <Button type="error" size="small" @click="remove(index)"
                          >Delete
                        </Button>
                        <Button type="error" size="small" @click="remove(index)"
                          >Delete
                        </Button>
                      </template>
                    </Table>
                    <p
                      class="buttonList"
                      style="
                        padding-left: 10px;
                        position: relative;
                        width: 100%;
                      "
                    >
                      <Button
                        style="margin: 2px"
                        type="success"
                        @click="exportModelExcel"
                        >导出模型
                      </Button>
                    </p>
                    <Page
                      :total="dataCountModel"
                      :current="dataCountModelCurrent"
                      :page-size="pageSizeModel"
                      show-total
                      @on-change="changepageModel"
                    ></Page>
                  </div>
                </div>

                <!-- 编辑 ** 规则展示 -->
                <div class="modelList" v-show="showModel">
                  <p
                    style="
                      text-align: right;
                      position: absolute;
                      right: 1%;
                      top: -15px;
                      min-width: 80px;
                    "
                  >
                    <Poptip
                      v-model="isModelHelp"
                      placement="right"
                      style="font-size: 18px; cursor: pointer"
                    >
                      <Icon type="ios-help-circle-outline" title="帮助" />
                      <div class="api" slot="content" style="background: #ccc">
                        <img :src="imgModelHelp" alt="" :style="imgStyle" />
                        <Icon
                          type="md-close-circle"
                          style="
                            color: red;
                            position: absolute;
                            font-size: 21px;
                          "
                          @click="closeHelp"
                          title="关闭"
                        />
                      </div>
                    </Poptip>
                    <ButtonGroup>
                      <Button
                        icon="md-archive"
                        title="保存模型"
                        type="success"
                        size="small"
                        @click="subModel"
                      ></Button>
                      <Button
                        icon="md-close"
                        title="关闭"
                        type="error"
                        size="small"
                        @click="closeModel"
                      ></Button>
                    </ButtonGroup>
                  </p>
                  <div class="formList">
                    <div style="padding: 10px; font-size: 14px">
                      <div class="textAlign">
                        <b>名称：</b>
                        <Input
                          v-model="currentEdit.name"
                          placeholder="模型名称"
                          id="modelName"
                          style="width: 15%; padding: 1px"
                          @on-blur="
                            ModelTestingName(currentEdit.name, 'modelName')
                          "
                        />
                        <b>状态：</b>
                        <Select
                          v-model="currentEdit.using"
                          style="width: 15%; padding: 1px"
                        >
                          <Option
                            v-for="item in stateIsOpen"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.label }}
                          </Option>
                        </Select>
                        <b>类型：</b>
                        <Select
                          v-model="currentEdit.rulesType"
                          :disabled="isDisabled"
                          @on-change="onRuleType"
                          style="width: 15%; padding: 1px"
                        >
                          <Option
                            v-for="item in ruleType"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.label }}
                          </Option>
                        </Select>
                        <b>负责人：</b>
                        <Input
                          v-model="currentEdit.userName"
                          placeholder="负责人"
                          style="width: 15%; padding: 1px"
                        />
                      </div>
                      <div style="padding-top: 1%" class="textAlign">
                        <b>描述：</b>
                        <Input
                          v-model="currentEdit.desc"
                          placeholder="描述"
                          type="textarea"
                          style="width: 77%; padding: 1px"
                          :rows="2"
                          :autosize="{ maxRows: 2, minRows: 2 }"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 规则表格 -->
                  <div
                    @click="queryButtonSpot('rule')"
                    title="搜索"
                    v-show="showRule"
                    style="
                      z-index: 80;
                      position: absolute;
                      right: 0px;
                      font-size: 25px;
                      cursor: pointer;
                    "
                  >
                    <Icon type="md-search" />
                  </div>
                  <div class="tableStyle" v-show="showRule">
                    <Table
                      @on-row-click="onTable"
                      :height="tableHeight4"
                      highlight-row
                      ref="selection"
                      :columns="ruleColumns"
                      :data="ruleData"
                    >
                      <template slot-scope="{ row, index }" slot="action">
                      </template>
                    </Table>
                    <Page
                      :total="dataCountRule"
                      :current="dataCountRuleCurrent"
                      :page-size="pageSizeRule"
                      show-total
                      @on-change="changepageRule"
                      style="position: absolute; bottom: 0px; right: 45%"
                    ></Page>
                  </div>

                  <div class="labelsD">
                    <div
                      style="
                        height: 35px;
                        line-height: 35px;
                        z-index: 10;
                        background: rgb(130, 193, 252, 0.5);
                      "
                    >
                      <span style="color: #2d8cf0">
                        {{ objList.name }}
                      </span>
                      <ButtonGroup
                        style="position: absolute; right: 3%; margin: 5px"
                      >
                        <Button
                          icon="md-archive"
                          title="提交"
                          type="success"
                          size="small"
                          @click="subRuleList"
                        ></Button>
                        <Button
                          icon="md-close"
                          title="关闭"
                          type="error"
                          size="small"
                          @click="colseRule"
                        ></Button>
                      </ButtonGroup>
                    </div>
                    <!-- 限制报警 -->
                    <div v-if="showRuleType == 'limitValue'" class="ruleStyle">
                      <!-- <div style="padding-left: 5%; padding-right: 45%;"> -->
                      <div style="padding-left: 15%; padding-right: 15%">
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >规则名称：</b
                          >
                          <Input
                            placeholder="规则名称..."
                            v-model="objList.name"
                            style="width: 718px; padding-bottom: 10px"
                            id="objListName"
                            @on-blur="
                              ModelTestingName(objList.name, 'objListName')
                            "
                          />
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >有效时间：</b
                          >
                          <DatePicker
                            type="datetime"
                            v-model="objList.startTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="padding-bottom: 10px; width: 315px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >失效时间：
                          <DatePicker
                            type="datetime"
                            v-model="objList.endTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="padding-bottom: 10px; width: 315px"
                          ></DatePicker>
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >预警级别：</b
                          >
                          <Select
                            v-model="objList.alarmLevel"
                            @on-change="onAlarmLevel"
                            style="width: 320px; padding-bottom: 10px"
                          >
                            <Option
                              v-for="item in levelList"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}
                            </Option>
                          </Select>
                          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
                          <Input
                            v-model="objList.tagUnit"
                            placeholder=""
                            style="width: 320px; padding-bottom: 10px"
                          />
                        </div>
                        <div
                          style="width: 820px"
                          v-show="enhanceAlarmLevelList"
                        >
                          <b>高限：</b>
                          <Input
                            v-model="objList.high"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.highDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;预警级别：
                          <Input
                            v-model="objList.highLevel"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />

                          <b>高&nbsp;&nbsp;高&nbsp;&nbsp;限：</b>
                          <Input
                            v-model="objList.hhigh"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.hhighDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;预警级别：
                          <Input
                            v-model="objList.hhighLevel"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          <b>低限：</b>
                          <Input
                            v-model="objList.low"
                            placeholder=""
                            type="number"
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.lowDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;预警级别：
                          <Input
                            v-model="objList.lowLevel"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />

                          <b>低&nbsp;&nbsp;低&nbsp;&nbsp;限：</b>
                          <Input
                            v-model="objList.llow"
                            placeholder=""
                            type="number"
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.llowDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;预警级别：
                          <Input
                            v-model="objList.llowLevel"
                            placeholder=""
                            style="width: 179px; padding-bottom: 10px"
                          />
                        </div>
                        <div style="width: 820px" v-show="alarmLevelList">
                          <b>高限：</b>
                          <Input
                            v-model="objList.high"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.highDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                          &nbsp;低&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;限：
                          <Input
                            v-model="objList.low"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.lowDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                          <b>高&nbsp;&nbsp;高&nbsp;&nbsp;限：</b>
                          <Input
                            v-model="objList.hhigh"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                            id="objListhhigh"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.hhighDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                          低&nbsp;&nbsp;低&nbsp;&nbsp;限：
                          <Input
                            v-model="objList.llow"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                            id="objListllow"
                          />
                          &nbsp;&nbsp;&nbsp;报警死区：
                          <Input
                            v-model="objList.llowDeadZone"
                            type="number"
                            placeholder=""
                            style="width: 114px; padding-bottom: 10px"
                          />
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                                text-align: right;
                              "
                              >*</i
                            >表&nbsp;达&nbsp;&nbsp;式：</b
                          >
                          <Input
                            v-model="objList.alarmRule"
                            @on-focus="onFocus(1)"
                            id="objListalarmRule"
                            @on-blur="
                              ModelTestingName(
                                objList.alarmRule,
                                'objListalarmRule'
                              )
                            "
                            style="width: 718px; padding-bottom: 1px"
                            placeholder="表达式..."
                            type="textarea"
                            :rows="4"
                            :autosize="{ maxRows: 4, minRows: 4 }"
                          />
                          <ButtonGroup
                            size="small"
                            vertical
                            v-show="isButtGroup"
                            style="position: absolute"
                          >
                            <Button
                              type="success"
                              style="margin-left: 1px"
                              icon="md-add"
                              title="点选"
                              @click="isOpenTable"
                            ></Button>
                          </ButtonGroup>
                          <Checkbox
                            v-model="objList.saveHisData"
                            style="
                              position: absolute;
                              margin-top: 30px;
                              margin-left: 5px;
                            "
                          >
                            保存历史
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    <!-- 自控持续 -->
                    <div v-if="showRuleType == 'continued'" class="ruleStyle">
                      <div style="padding-left: 15%; padding-right: 15%">
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >规则名称：</b
                          >
                          <Input
                            v-model="objList.name"
                            placeholder=""
                            style="width: 718px; padding-bottom: 10px"
                            id="objListname"
                            @on-blur="
                              ModelTestingName(objList.name, 'objListname')
                            "
                          />
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >有效时间：</b
                          >
                          <DatePicker
                            type="datetime"
                            v-model="objList.startTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px; padding: 1px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >失效时间：
                          <DatePicker
                            type="datetime"
                            v-model="objList.endTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px; padding-bottom: 10px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >持续时间：
                          <Input
                            placeholder=""
                            v-model="objList.timeLength"
                            style="width: 160px; display: inline-table"
                            id="objListduration"
                            @on-blur="
                              ModelTestingName(
                                objList.timeLength,
                                'objListduration'
                              )
                            "
                          >
                            <span slot="append">/秒</span>
                          </Input>
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >预警级别：</b
                          >
                          <Select
                            v-model="objList.alarmLevel"
                            style="width: 182px; padding-bottom: 10px"
                          >
                            <Option
                              v-for="item in levelLists"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}
                            </Option>
                            >
                          </Select>
                          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
                          <Input
                            v-model="objList.tagUnit"
                            placeholder=""
                            style="width: 187px; padding-bottom: 10px"
                          />
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >趋势状态：
                          <Select
                            v-model="objList.dataState"
                            style="width: 187px; padding: 1px"
                          >
                            <Option :value="0">向上</Option>
                            <Option :value="2">不变</Option>
                            <Option :value="1">向下</Option>
                          </Select>
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                                text-align: right;
                              "
                              >*</i
                            >表&nbsp;达&nbsp;&nbsp;式：</b
                          >
                          <Input
                            v-model="objList.condition"
                            @on-focus="onFocus1(1)"
                            id="objListcondition"
                            @on-blur="
                              ModelTestingName(
                                objList.condition,
                                'objListcondition'
                              )
                            "
                            style="width: 718px; padding-bottom: 1px"
                            placeholder="表达式..."
                            type="textarea"
                            :rows="4"
                            :autosize="{ maxRows: 4, minRows: 4 }"
                          />
                          <ButtonGroup
                            size="small"
                            vertical
                            v-show="isButtGroup"
                            style="position: absolute"
                          >
                            <Button
                              type="success"
                              style="margin-left: 1px"
                              icon="md-add"
                              title="点选"
                              @click="isOpenTable"
                            ></Button>
                          </ButtonGroup>
                          <Checkbox
                            v-model="objList.saveHisData"
                            style="
                              position: absolute;
                              margin-top: 30px;
                              margin-left: 5px;
                            "
                          >
                            保存历史
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    <!-- 自控实时 -->
                    <div v-if="showRuleType == 'realTime'" class="ruleStyle">
                      <div style="padding-left: 15%; padding-right: 15%">
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >规则名称：</b
                          >
                          <Input
                            v-model="objList.name"
                            placeholder=""
                            style="width: 718px; padding-bottom: 10px"
                            id="objListname"
                            @on-blur="
                              ModelTestingName(objList.name, 'objListname')
                            "
                          />
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >有效时间：</b
                          >
                          <DatePicker
                            type="datetime"
                            v-model="objList.startTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 315px; padding-bottom: 10px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >失效时间：
                          <DatePicker
                            type="datetime"
                            v-model="objList.endTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 315px; padding-bottom: 10px"
                          ></DatePicker>
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >预警级别：</b
                          >
                          <Select
                            v-model="objList.alarmLevel"
                            style="width: 320px; padding-bottom: 10px"
                          >
                            <Option
                              v-for="item in levelLists"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}
                            </Option>
                            >
                          </Select>
                          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
                          <Input
                            v-model="objList.tagUnit"
                            placeholder=""
                            style="width: 320px; padding-bottom: 10px"
                          />
                        </div>
                        <div style="width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                                text-align: right;
                              "
                              >*</i
                            >表&nbsp;达&nbsp;&nbsp;式：</b
                          >
                          <Input
                            v-model="objList.alarmRule"
                            @on-focus="onFocus(1)"
                            id="objListalarmRule"
                            @on-blur="
                              ModelTestingName(
                                objList.alarmRule,
                                'objListalarmRule'
                              )
                            "
                            placeholder="表达式..."
                            type="textarea"
                            style="width: 718px; padding-bottom: 1px"
                            :rows="4"
                            :autosize="{ maxRows: 4, minRows: 4 }"
                          />
                          <ButtonGroup
                            size="small"
                            vertical
                            v-show="isButtGroup"
                            style="position: absolute"
                          >
                            <Button
                              type="success"
                              style="margin-left: 1px"
                              icon="md-add"
                              title="点选"
                              @click="isOpenTable"
                            ></Button>
                          </ButtonGroup>
                          <Checkbox
                            v-model="objList.saveHisData"
                            style="
                              position: absolute;
                              margin-top: 30px;
                              margin-left: 5px;
                            "
                          >
                            保存历史
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    <!-- 连续报警 -->
                    <div v-if="showRuleType == 'continuity'" class="ruleStyle">
                      <div style="padding-left: 15%; padding-right: 15%">
                        <div style="padding-bottom: ; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >规则名称：</b
                          >
                          <Input
                            placeholder=""
                            v-model="objList.name"
                            style="width: 718px; padding-bottom: 10px"
                            id="objListname"
                            @on-blur="
                              ModelTestingName(objList.name, 'objListname')
                            "
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >有效时间：</b
                          >
                          <DatePicker
                            type="datetime"
                            v-model="objList.startTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px; padding: 1px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >失效时间：
                          <DatePicker
                            type="datetime"
                            v-model="objList.endTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px; padding: 1px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >连续次数：
                          <Input
                            placeholder=""
                            v-model="objList.evaluateConut"
                            style="width: 160px; padding: 1px"
                            id="objListevaluateConut"
                            @on-blur="
                              ModelTestingName(
                                objList.evaluateConut,
                                'objListevaluateConut'
                              )
                            "
                            @on-keyup="
                              objList.high = objList.high.replace(/[^\d]/g, '')
                            "
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >预警级别：</b
                          >
                          <Select
                            v-model="objList.alarmLevel"
                            style="width: 191px"
                          >
                            <Option
                              v-for="item in levelLists"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}
                            </Option>
                            >
                          </Select>
                          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
                          <Input
                            <Input
                            v-model="objList.tagUnit"
                            placeholder=""
                            style="width: 191px"
                          />
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >变化幅度：
                          <Input
                            v-model="objList.Increase"
                            placeholder=""
                            style="width: 170px"
                            id="objListIncrease"
                            @on-blur="
                              ModelTestingName(
                                objList.Increase,
                                'objListIncrease'
                              )
                            "
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                                text-align: right;
                              "
                              >*</i
                            >表&nbsp;达&nbsp;&nbsp;式：</b
                          >
                          <Input
                            v-model="objList.alarmRule"
                            @on-focus="onFocus(1)"
                            id="objListalarmRule"
                            @on-blur="
                              ModelTestingName(
                                objList.alarmRule,
                                'objListalarmRule'
                              )
                            "
                            placeholder="表达式..."
                            type="textarea"
                            style="width: 718px; padding-bottom: 1px"
                            :rows="4"
                            :autosize="{ maxRows: 4, minRows: 4 }"
                          />
                          <ButtonGroup
                            size="small"
                            vertical
                            v-show="isButtGroup"
                            style="position: absolute"
                          >
                            <Button
                              type="success"
                              style="margin-left: 1px"
                              icon="md-add"
                              title="点选"
                              @click="isOpenTable"
                            ></Button>
                          </ButtonGroup>
                          <Checkbox
                            v-model="objList.saveHisData"
                            style="
                              position: absolute;
                              margin-top: 30px;
                              margin-left: 5px;
                            "
                          >
                            保存历史
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    <!-- 缺陷报警 -->
                    <div v-if="showRuleType == 'defect'" class="ruleStyle">
                      <div style="padding-left: 15%; padding-right: 15%">
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >规则名称：</b
                          >
                          <Input
                            v-model="objList.name"
                            placeholder=""
                            style="width: 718px"
                            id="objListname"
                            @on-blur="
                              ModelTestingName(objList.name, 'objListname')
                            "
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >有效时间：</b
                          >
                          <DatePicker
                            type="datetime"
                            v-model="objList.startTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >失效时间：
                          <DatePicker
                            type="datetime"
                            v-model="objList.endTime"
                            format="yyyy年MM月dd日 HH:mm"
                            style="width: 191px"
                          ></DatePicker>
                          <i
                            style="
                              color: red;
                              width: 10px;
                              display: inline-flex;
                            "
                            >*</i
                          >缺陷次数：
                          <Input
                            placeholder=""
                            v-model="objList.evaluateConut"
                            style="width: 160px"
                            id="objListevaluateConut"
                            @on-blur="
                              ModelTestingName(
                                objList.evaluateConut,
                                'objListevaluateConut'
                              )
                            "
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                              "
                              >*</i
                            >预警级别：</b
                          >
                          <Select
                            v-model="objList.alarmLevel"
                            style="width: 320px"
                          >
                            <Option
                              v-for="item in levelLists"
                              :value="item.value"
                              :key="item.value"
                              >{{ item.label }}
                            </Option>
                            >
                          </Select>
                          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
                          <Input
                            v-model="objList.tagUnit"
                            placeholder=""
                            style="width: 320px"
                          />
                        </div>
                        <div style="padding-bottom: 10px; width: 820px">
                          <b
                            ><i
                              style="
                                color: red;
                                width: 10px;
                                display: inline-flex;
                                text-align: right;
                              "
                              >*</i
                            >表&nbsp;达&nbsp;&nbsp;式：</b
                          >
                          <Input
                            v-model="objList.alarmRule"
                            @on-focus="onFocus(1)"
                            id="objListalarmRule"
                            @on-blur="
                              ModelTestingName(
                                objList.alarmRule,
                                'objListalarmRule'
                              )
                            "
                            placeholder="表达式..."
                            type="textarea"
                            style="width: 718px; padding-bottom: 1px"
                            :rows="4"
                            :autosize="{ maxRows: 4, minRows: 4 }"
                          />
                          <ButtonGroup
                            size="small"
                            vertical
                            v-show="isButtGroup"
                            style="position: absolute"
                          >
                            <Button
                              type="success"
                              style="margin-left: 1px"
                              icon="md-add"
                              title="点选"
                              @click="isOpenTable"
                            ></Button>
                          </ButtonGroup>
                          <Checkbox
                            v-model="objList.saveHisData"
                            style="
                              position: absolute;
                              margin-top: 30px;
                              margin-left: 5px;
                            "
                          >
                            保存历史
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Drawer
                  id="drawer"
                  title="双击选择点"
                  v-model="openTable"
                  width="720"
                  :mask-closable="false"
                  :styles="stylesDrawer"
                >
                  <Table
                    :height="tableHeight2"
                    @on-row-dblclick="onDblData"
                    highlight-row
                    ref="selection"
                    :columns="tableColumns1"
                    :data="tableData1"
                  ></Table>
                  <Button
                    class="loadMoreStyle"
                    size="small"
                    type="success"
                    v-show="true"
                    :loading="loading"
                    @click="loadMoreTag"
                    >加载更多...
                  </Button>
                  <div
                    style="height: 48px; border-bottom: 1px solid #e8eaec"
                    @dblclick="onDblDataList"
                  >
                    <span
                      style="
                        display: inline-block;
                        width: 50%;
                        height: 100%;
                        margin: auto;
                        text-align: left;
                        padding-left: 18px;
                        padding-top: 15px;
                      "
                    >
                      {{ nodeTreeTitle }}</span
                    >
                    <span
                      style="
                        display: inline-block;
                        width: 49%;
                        height: 100%;
                        margin: auto;
                        text-align: center;
                        padding-left: 18px;
                        padding-top: 15px;
                      "
                      >节点名</span
                    >
                  </div>
                </Drawer>
              </div>
            </Tab-pane>
            <Tab-pane label="数据">
              <div class="labels">
                <Table
                  @on-row-click="onTable"
                  :height="tableHeight"
                  highlight-row
                  ref="selection"
                  :columns="tableOperation"
                  :data="dataOperation"
                >
                  <template slot-scope="{ row, index }" slot="action">
                    <Button
                      type="primary"
                      size="small"
                      style="margin-right: 5px"
                      @click="show(index)"
                      >View
                    </Button>
                    <Button type="error" size="small" @click="remove(index)"
                      >Delete
                    </Button>
                    <Button type="error" size="small" @click="remove(index)"
                      >Delete
                    </Button>
                  </template>
                </Table>

                <p
                  class="buttonList"
                  style="padding-left: 10px; position: relative; width: 100%"
                >
                  <Upload :action="uploadSpot" :on-success="importSpot">
                    <Button type="primary">导入测点</Button>
                  </Upload>
                  <Upload :action="uploadModels" :on-success="importModels">
                    <Button type="primary">导入模型</Button>
                  </Upload>
                  <Button style="margin: 2px" icon="ios-copy" @click="backups()"
                    >备份
                  </Button>
                </p>
                <Page
                  :total="operationCount"
                  :current="operationCountCurrent"
                  :page-size="pageSizeOperation"
                  show-total
                  @on-change="changepageOperation"
                ></Page>
              </div>
            </Tab-pane>
          </Tabs>
        </div>
      </Split>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { rejects } from "assert";
import { callbackify, log } from "util";

class model {
  constructor(onModelEdit, data) {
    this.onModelEdit = onModelEdit;
    if (data) {
      this.name = data.name || "";
      this.name = data.name || "";
      this.userName = data.userName || "";
      this.using = data.using || "";
      this.sights = data.sights || "";
      this.rulesType = data.rulesType || "";
      this.desc = data.desc || "";
      this.alarmRules = [];
    } else {
      this.name = "";
      this.userName = "";
      this.using = 0;
      this.sights = "";
      this.rulesType = "limitValue";
      this.alarmRules = [];
    }

    for (var p in data) {
      if (p == "alarmRules") {
        for (var i = 0; i < data.alarmRules.length; i++) {
          this.alarmRules[i] = new ruleClass[data.rulesType](
            this.onModelEdit,
            data.alarmRules[i]
          );
        }
      } else {
        this[p] = data[p];
      }
    }
    this.init();
  }

  getAlarmRules() {
    var data = [];
    for (var i = 0; i < this.alarmRules.length; i++) {
      data.push(this.alarmRules[i].getData());
    }
    return data;
  }

  /**
   * 检查字符串是否包含特殊符号
   */
  stripscript(even) {
    var flag = new RegExp(
      "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
    );
    var test = [
      "~",
      "!",
      "@",
      "#",
      "$",
      "^",
      "&",
      "*",
      "(",
      ")",
      "=",
      "|",
      "{",
      "}",
      ":",
      ";",
      ",",
      "\\",
      "/",
      "[",
      "]",
      ".",
      "<",
      ">",
      "《",
      "》",
      "/",
      "?",
      "~",
      "！",
      "@",
      "#",
      "￥",
      "…",
      "（",
      "）",
      "—",
      "|",
      "【",
      "】",
      "‘",
      "；",
      "：",
      "”",
      "“",
      "。",
      "，",
      "、",
      "？",
    ];
    // 判断 even 是否包含特殊字符
    if (flag.test(even)) {
      for (var i = 0; i < test.length; i++) {
        if (even.indexOf(test[i]) >= 0) {
          return test[i];
        }
      }
      return "未识别的特殊符号";
    } else {
      return false;
    }
  }

  init() {
    this.translationEnglish();
    if (this.using == "启用" || this.using == true) {
      this.using = 0;
    } else if (this.using == "停用" || this.using == false) {
      this.using = 1;
    }
    //修改时间 转换
    for (var k in this.alarmRules) {
      this.alarmRules[k].convertUTCTimeToLocalTime();
    }
  }

  //转译报警类型 中文
  static getTypeStr(rulesType) {
    switch (rulesType) {
      case "limitValue":
        return "限制报警";
      case "continued":
        return "自控持续";
      case "realTime":
        return "自控实时";
      case "continuity":
        return "连续性报警";
      case "defect":
        return "缺陷报警";
      default:
        return "限制报警";
    }
  }

  //转译报警类型 英文
  translationEnglish() {
    switch (this.rulesType) {
      case "限制报警":
        this.rulesType = "limitValue";
      case "自控持续":
        this.rulesType = "continued";
      case "自控实时":
        this.rulesType = "realTime";
      case "连续性报警":
        this.rulesType = "continuity";
      case "缺陷报警":
        this.rulesType = "defect";
    }
  }

  async getError(error, isClose, parent) {
    if (this.name == "") {
      return "模型名称不能为空";
    } else {
      var temp = this.stripscript(this.name);
      if (temp) {
        return `模型名称不能包含特殊符号:${temp}`;
      }
    }
    if (this.alarmRules == undefined || this.alarmRules.length == 0) {
      return "请至少创建一条规则";
    }
    if (error && isClose) {
      return await new Promise((resolved, rejected) => {
        parent.$Modal.confirm({
          title: "系统",
          content: "<p>是否放弃本次添加/修改</p>",
          onOk: () => {
            resolved(false);
          },
          onCancel: () => {
            resolved(error);
          },
        });
      });
    }
    return false;
  }
}

class base {
  constructor(onModelEdit, data) {
    this.onModelEdit = onModelEdit;
    this.name = "";
    this.startTime = new Date();
    var nEndTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
    this.endTime = new Date(nEndTime);
    this.alarmLevel = "3";
    this.tagUnit = "";
    this.alarmRule = "";
    if (data) {
      this.id = data.id;
    } else {
      this.id = this.createRandomId();
    }

    for (var p in data) {
      this[p] = data[p];
    }
  }

  createRandomId() {
    return (
      (Math.random() * 10000000).toString(16).substr(0, 4) +
      "-" +
      new Date().getTime() +
      "-" +
      Math.random().toString().substr(2, 5)
    );
  }

  getData() {
    if (this.id) {
      this.id = this.id;
    } else {
      this.id = this.createRandomId();
    }
    return {
      id: this.id,
      name: this.name,
      startTime: this.startTime,
      endTime: this.endTime,
      alarmLevel: this.alarmLevel,
      tagUnit: this.tagUnit,
      alarmRule: this.alarmRule,
    };
  }

  /**
   * 检查字符串是否包含特殊符号
   */
  stripscript(even) {
    var flag = new RegExp(
      "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
    );
    var test = [
      "~",
      "!",
      "@",
      "#",
      "$",
      "^",
      "&",
      "*",
      "(",
      ")",
      "=",
      "|",
      "{",
      "}",
      ":",
      ";",
      ",",
      "\\",
      "/",
      "[",
      "]",
      ".",
      "<",
      ">",
      "《",
      "》",
      "/",
      "?",
      "~",
      "！",
      "@",
      "#",
      "￥",
      "…",
      "（",
      "）",
      "—",
      "|",
      "【",
      "】",
      "‘",
      "；",
      "：",
      "”",
      "“",
      "。",
      "，",
      "、",
      "？",
    ];
    // 判断 even 是否包含特殊字符
    if (flag.test(even)) {
      for (var i = 0; i < test.length; i++) {
        if (even.indexOf(test[i]) >= 0) {
          return test[i];
        }
      }
      return "未识别的特殊符号";
    } else {
      return false;
    }
  }

  async getError(error, isClose, parent) {
    if (this.name == "") {
      error = "规则名称不能为空";
    } else {
      var temp = this.stripscript(this.name);
      if (temp) {
        error = `规则名称不能包含特殊符号:${temp}`;
      }
    }
    if (this.startTime == "" || this.endTime == "") {
      error = "请设置一个此规则的有效时间";
    }
    if (this.alarmRule == "") {
      error = "规则表达式不能为空";
    }
    if (error && isClose) {
      return await new Promise((resolved, rejected) => {
        parent.$Modal.confirm({
          title: "系统",
          content: "<p>是否放弃本次添加/修改</p>",
          onOk: () => {
            resolved(false);
          },
          onCancel: () => {
            resolved(error);
          },
        });
      });
    }
    return error;
  }

  //时间转换
  convertUTCTimeToLocalTime() {
    this.startTime = this.localTime(this.startTime);
    this.endTime = this.localTime(this.endTime);
  }

  localTime(UTCDateString) {
    if (!UTCDateString) {
      return "-";
    }

    function formatFunc(str) {
      //格式化显示
      return str > 9 ? str : "0" + str;
    }

    var date2 = new Date(UTCDateString); //这步是关键
    var year = date2.getFullYear();
    var mon = formatFunc(date2.getMonth() + 1);
    var day = formatFunc(date2.getDate());
    var hour = date2.getHours();
    hour = formatFunc(hour);
    var min = formatFunc(date2.getMinutes());
    var second = formatFunc(date2.getSeconds());
    var dateStr =
      year + "-" + mon + "-" + day + " " + hour + ":" + min + ":" + "" + second;
    return dateStr;
  }
}

class limitValue extends base {
  constructor(onModelEdit, data) {
    super(onModelEdit, data);
    if (!data) {
      var data = onModelEdit;
    }
    this.type = data.type || "limitValue";
    this.saveHisData = data.saveHisData != undefined ? data.saveHisData : false;
    this.high = data.high != undefined ? data.high : ""; // 高限
    this.low = data.low != undefined ? data.low : ""; // 低限
    this.hhigh = data.hhigh != undefined ? data.hhigh : ""; // 高高限
    this.llow = data.llow != undefined ? data.llow : ""; // 低低限

    //死区
    this.highDeadZone = data.highDeadZone != undefined ? data.highDeadZone : "";
    this.lowDeadZone = data.lowDeadZone != undefined ? data.lowDeadZone : "";
    this.hhighDeadZone =
      data.hhighDeadZone != undefined ? data.hhighDeadZone : "";
    this.llowDeadZone = data.llowDeadZone != undefined ? data.llowDeadZone : "";

    this.highLevel = data.highLevel != undefined ? data.highLevel : ""; // 高限
    this.lowLevel = data.lowLevel != undefined ? data.lowLevel : ""; // 低限
    this.hhighLevel = data.hhighLevel != undefined ? data.hhighLevel : ""; // 高高限
    this.llowLevel = data.llowLevel != undefined ? data.llowLevel : ""; // 低低限
  }

  getData() {
    var data = super.getData();
    data.type = this.type;
    data.saveHisData = this.saveHisData;
    data.high = this.high; // 高限
    data.low = this.low; // 低限
    data.hhigh = this.hhigh; // 高高限
    data.llow = this.llow; // 低低限
    //死区
    data.highDeadZone = this.highDeadZone;
    data.lowDeadZone = this.lowDeadZone;
    data.hhighDeadZone = this.hhighDeadZone;
    data.llowDeadZone = this.llowDeadZone;

    data.typeLevel = this.typeLevel;
    data.highLevel = this.highLevel; // 高限
    data.lowLevel = this.lowLevel; // 低限
    data.hhighLevel = this.hhighLevel; // 高高限
    data.llowLevel = this.llowLevel; // 低低限

    return data;
  }

  async getError(isClose, parent) {
    var error = false;
    if (
      this.high == "" &&
      this.low == "" &&
      this.hhigh == "" &&
      this.llow == ""
    ) {
      error = "至少配置一种限值";
    }
    error = await super.getError(error, isClose, parent);
    return error;
  }
}

class continued extends base {
  constructor(parent, data) {
    super(parent, data);
    if (!data) {
      var data = onModelEdit;
    }
    this.type = data.type || "continued";
    this.saveHisData = data.saveHisData != undefined ? data.saveHisData : false;
    this.dataState = data.dataState; //趋势状态 012
    this.condition = data.condition || ""; //趋势脚本
    this.saveHisData = data.saveHisData || false;
    this.timeLength = data.timeLength || "";
  }

  getData() {
    var data = super.getData();
    data.type = this.type;
    data.saveHisData = this.saveHisData;
    data.dataState = this.dataState;
    data.condition = this.condition;
    data.saveHisData = this.saveHisData;
    data.timeLength = this.timeLength;
    return data;
  }

  async getError(isClose, parent) {
    var error = false;
    if (error) {
      return error;
    }
    if (this.timeLength == "") {
      error = "timeLength不能为空";
    }
    // if(this.condition == ""){
    //     error = "报警频率不能为空";
    // }
    error = await super.getError(error, isClose, parent);
    return error;
  }
}

class realTime extends base {
  constructor(parent, data) {
    super(parent, data);
    if (!data) {
      var data = onModelEdit;
    }
    this.type = data.type || "realTime";
    this.saveHisData = data.saveHisData != undefined ? data.saveHisData : false;
    this.alarmFrequency = data.alarmFrequency || ""; // 报警频率
  }

  getData() {
    var data = super.getData();
    data.type = this.type;
    data.saveHisData = this.saveHisData;
    data.alarmFrequency = this.alarmFrequency;
    return data;
  }

  async getError(isClose, parent) {
    var error = false;
    if (error) {
      return error;
    }
    // if(this.alarmFrequency == ""){
    //     error = "报警频率不能为空";
    // }
    error = await super.getError(error, isClose, parent);
    return error;
  }
}

class continuity extends base {
  constructor(parent, data) {
    super(parent, data);
    if (!data) {
      var data = onModelEdit;
    }
    this.type = data.type || "continuity";
    this.saveHisData = data.saveHisData != undefined ? data.saveHisData : false;
    this.Increase = data.Increase || ""; //幅度
    this.evaluateConut = data.evaluateConut || 2; //连续次数
  }

  getData() {
    var data = super.getData();
    data.saveHisData = this.saveHisData;
    data.Increase = this.Increase;
    data.evaluateConut = this.evaluateConut;
    return data;
  }

  async getError(isClose, parent) {
    var error = false;
    if (error) {
      return error;
    }
    if (this.Increase == "") {
      error = "变化幅度不能为空";
    }
    error = await super.getError(error, isClose, parent);
    return error;
  }
}

class defect extends base {
  constructor(parent, data) {
    super(parent, data);
    if (!data) {
      var data = onModelEdit;
    }
    this.type = data.type || "defect";
    this.saveHisData = data.saveHisData != undefined ? data.saveHisData : false;
    this.evaluateConut = data.evaluateConut || ""; //缺陷次数
  }

  getData() {
    var data = super.getData();
    data.saveHisData = this.saveHisData;
    data.evaluateConut = this.evaluateConut;
    return data;
  }

  async getError(isClose, parent) {
    var error = false;
    if (error) {
      return error;
    }
    if (this.evaluateConut == "") {
      error = "缺陷次数不能为空";
    }
    error = await super.getError(error, isClose, parent);
    return error;
  }
}

window.ruleClass = {
  limitValue: limitValue,
  continued: continued,
  realTime: realTime,
  continuity: continuity,
  defect: defect,
};
export default {
  name: "alarmCenter",
  mounted() {
    this.$store.registerModule(["system", "alarmCenter"], {
      state: {
        $: this,
      },
    });
  },
  data() {
    return {
      imgStyle: {
        width: innerWidth * 0.75 + "px",
        height: innerHeight * 0.85 + "px",
        margin: "5px",
      },
      querydata: [],
      isQuery: false,
      queryListName: "",
      searchText: "",
      tagListJosn: {},
      spinShow: false,
      enhanceAlarmLevelList: false,
      alarmLevelList: true,
      isLoadMore: true,
      queryName: "",
      queryDescName: "",
      uploadSpot: debugFWebView + "alarmCenter/tags",
      uploadModels: debugFWebView + "alarmCenter/models",
      count: 1000,
      loading: true,
      loading1: true,
      imgModelHelp: require("../../assets/Help/limitValue.gif"),
      imgHelp: require("../../assets/Help/测点.gif"),
      imgTreeHelp: require("../../assets/Help/树节点.gif"),
      isHelp: false, //设置关闭帮助弹出窗
      isModelHelp: false,
      isTreeHelp: false,
      isAble: true, //设置下拉框选项是否禁用
      isOnRule: false, //编辑规则标记
      isButtGroup: true, //点选趋势按钮显隐
      imgSrc: require("../../assets/logo1.png"),
      //登录名称
      loginName: "",
      addButton: "tag",
      treeStyleNode: {},
      menuObj: "",
      split1: 0.15,
      isDisabled: true, //判断规则下拉框是否禁用
      objList: [], //规则 数组
      condition: -9999, //趋势脚本 标记
      signNumber: -9999, // 表达式下标标记
      /** 测点目录的 表单*/
      newNode: "", //添加节点 input
      spotName: "", //查询点  input
      descName: "", //查询点描述  input
      nodeRename: "", //重命名  input

      onTableData: [], //存储表格选中的数据

      tabsNumber: 0, //切换标签 标识
      menuShow: false, //菜单显隐
      showModel: false, //模型显示
      modal1: false, //新增窗口 打开
      modal3: false, //重命名 打开
      modal4: false, //新增点 打开
      ajaxHistoryData: [], //用测点于分页
      ajaxHistoryData1: [], //用于模型分页
      ajaxHistoryData2: [], //用于规则分页
      ajaxHistoryData3: [], //用于数据分页
      // 初始化信息总条数
      dataCount: 0,
      dataCountModel: 0,
      dataCountRule: 0,
      operationCount: 0,
      //初始化选中分页
      dataCountCurrent: 1,
      dataCountModelCurrent: 1,
      dataCountRuleCurrent: 1,
      operationCountCurrent: 1,
      // 每页显示多少条
      pageSize: Math.trunc((innerHeight - 100) / 48),
      pageSizeModel: Math.trunc((innerHeight - 100) / 48),
      pageSizeRule: Math.trunc((innerHeight - 100 - innerHeight * 0.2) / 48),
      pageSizeOperation: Math.trunc((innerHeight - 100) / 48),
      showRule: false,
      //规则表头
      ruleColumns: [
        {
          title: "名称",
          // align: 'center',
          width: (window.innerWidth * 0.85) / 4,
          key: "name",
        },
        {
          title: " 级别",
          align: "center",
          width: (window.innerWidth * 0.85) / 10,
          key: "alarmLevel",
        },
        {
          title: "单位",
          align: "center",
          width: (window.innerWidth * 0.85) / 6,
          key: "tagUnit",
        },
        {
          title: "开始时间",
          align: "center",
          width: (window.innerWidth * 0.85) / 6,
          key: "startTime",
        },
        {
          title: "结束时间",
          align: "center",
          width: (window.innerWidth * 0.85) / 6,
          key: "endTime",
        },
        {
          title: "操作",
          key: "action",
          width: (window.innerWidth * 0.84) / 6,
          align: "center",
          render: (h, params, data) => {
            return h("ButtonGroup", [
              h("Button", {
                props: {
                  type: "primary",
                  size: "small",
                  icon: "ios-create-outline",
                },
                style: {},
                on: {
                  click: () => {
                    this.paramsRow = params.row;
                    this.onEdit(params.row);
                  },
                },
                attrs: {
                  title: "编辑",
                },
              }),
              h("Button", {
                props: {
                  type: "error",
                  size: "small",
                  icon: "ios-trash-outline",
                },
                on: {
                  click: () => {
                    this.delRule(params);
                  },
                },
                attrs: {
                  title: "删除规则",
                },
              }),
            ]);
          },
        },
      ],
      //规则数据
      ruleData: [],
      //测点表头
      historyColumns: [
        {
          title: "名称",
          // align: 'center',
          key: "name",
        },
        {
          title: "描述",
          // align: 'center',
          key: "desc",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("ButtonGroup", [
              h("Button", {
                props: {
                  type: "error",
                  size: "small",
                  icon: "ios-trash-outline",
                },
                on: {
                  click: () => {
                    this.onDelSpot(params.row);
                  },
                },
                attrs: {
                  title: "删除点",
                },
              }),
            ]);
          },
        },
      ],
      historyData: [], //测点数据
      //模型表格表头
      modelColumns: [
        {
          title: "名称",
          // align: 'center',
          key: "name",
        },
        {
          title: "状态",
          key: "using",
          width: 100,
          render: (h, params, data) => {
            return h(
              "Select",
              {
                props: {
                  value: params.row.using ? 0 : 1,
                  size: "small",
                },
                on: {
                  "on-change": (event) => {
                    //改变当前的值
                    params.row.using = !params.row.using;
                    this.menuParents(params, "no");
                    this.using = params.row.using ? 0 : 1;
                    this.currentEdit.using = this.using;
                    //调用保存
                    this.subModel();
                  },
                },
              },
              [
                h(
                  "Option",
                  {
                    props: {
                      value: 0,
                    },
                  },
                  "启用"
                ),
                h(
                  "Option",
                  {
                    props: {
                      value: 1,
                    },
                  },
                  "停用"
                ),
              ]
            );
          },
        },
        {
          title: "类型",
          align: "center",
          key: "rulesShowType",
        },
        {
          title: "描述",
          align: "center",
          key: "desc",
        },
        {
          title: "操作员",
          align: "center",
          key: "userName",
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params, data) => {
            return h("ButtonGroup", [
              h("Button", {
                props: {
                  type: "primary",
                  size: "small",
                  icon: "ios-create-outline",
                },
                style: {},
                on: {
                  click: () => {
                    this.parentValue = params;
                    this.tableWidth = 100;
                    this.menuParents(params);
                  },
                },
                attrs: {
                  title: "编辑模型&规则",
                },
              }),
              h("Button", {
                props: {
                  type: "error",
                  size: "small",
                  icon: "ios-trash-outline",
                },
                on: {
                  click: () => {
                    this.delNodes(params);
                  },
                },
                attrs: {
                  title: "删除",
                },
              }),
            ]);
          },
        },
      ],
      //模型表格数据
      modelData: [],
      //报警模型表头
      tableColumns1: [
        {
          title: "名称",
          key: "name",
        },
        {
          title: "描述",
          align: "center",
          key: "desc",
        },
      ],
      //报警模型数据
      tableData1: [],
      //添加点的表格
      additionsTable: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "名称",
          key: "NAME",
        },
        {
          title: "描述",
          key: "DESC",
        },
      ],
      columnsData: [], //添加点表格 数据
      allData: [],
      openButton: false, //是否打开软键盘
      openTable: false, //报警模型表格 是否显示
      isShow: false, //首次打开页面
      height: window.innerHeight * 0.99,
      //树节点数据
      dataTree: [],
      //表格高度
      tableHeight: innerHeight - 90,
      tableHeight2: innerHeight - 140,
      tableHeight3: innerHeight / 2,
      tableHeight4: innerHeight * 0.7,
      //推拉框样式
      stylesDrawer: {
        height: "calc(100% - 55px)",
        overflow: "hidden",
        paddingBottom: "53px",
        position: "static",
      },
      nodeTreeTitle: "",
      width: "100px",
      ruleType: [
        //报警规则
        {
          value: "limitValue",
          label: "限值报警",
        },
        {
          value: "continued",
          label: "自控持续",
        },
        {
          value: "realTime",
          label: "自控实时",
        },
        {
          value: "continuity",
          label: "连续性报警",
        },
        {
          value: "defect",
          label: "缺陷报警",
        },
      ],
      stateIsOpen: [
        //是否启用
        {
          value: 0,
          label: "启用",
        },
        {
          value: 1,
          label: "停用",
        },
      ],
      levelList: [
        //是否启用
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: -1,
          label: "自定义级别",
        },
      ],
      levelLists: [
        //是否启用
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      //数据操作表格
      tableOperation: [
        // {
        //     type: 'selection',
        //     width: 60,
        //     align: 'center'
        // },
        {
          title: "名称",
          key: "name",
        },
        {
          title: "用户",
          key: "user",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          render: (h, params, data) => {
            return h("div", [
              h("Button", {
                props: {
                  type: "info",
                  size: "small",
                  icon: "ios-refresh-circle",
                },
                style: {},
                on: {
                  click: () => {
                    this.recovery(params.row);
                    //更新列表
                    this.getDateList();
                  },
                },
                attrs: {
                  title: "恢复",
                },
              }),
              h("Button", {
                props: {
                  type: "error",
                  size: "small",
                  icon: "ios-trash-outline",
                },
                on: {
                  click: () => {
                    this.deletee(params.row);
                  },
                },
                attrs: {
                  title: "删除",
                },
              }),
            ]);
          },
        },
      ],
      dataOperation: [],
      openModelType: "add", //"add/edit"
      openRuleType: "add", //"add/edit"
      showRuleType: "",
      currentEdit: new model(this),
    };
  },
  methods: {
    // 过滤$符号
    removerDollar(arr, property) {
      arr.forEach((value, index) => {
        arr[index][property] = value[property].toString().replace(/\$/g, "");
      });
      return arr;
    },
    // 数组去重
    noRepeat(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i] === arr[j]) {
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr;
    },
    // ***********************************导出Excel start*********************************
    // 导出模型
    exportModelExcel() {
      // console.log(this.modalData)
      // 所有数据
      if (!this.modalData.length) {
        this.$Message.error("未添加模型!!!");
      } else {
        // 表格数据
        let list = [
          [
            ["模型名称", "启用", "更新人", "储存历史", "规则类型", "规则行号"],
            [
              "name",
              "using",
              "userName",
              "saveHisData",
              "rulesType",
              "alarmRules",
            ],
          ], // 模型
          // [['规则名称', '起效时间', '失效时间', '表达式', '预警级别', '报警单位', '趋势状态', '持续时间'], ['name', 'startTime', 'endTime', 'alarmRules', 'alarmLevel', 'tagUnit']],// continued
          // [['规则名称', '起效时间', '失效时间', '表达式', '预警级别', '报警单位'], ['name', 'startTime', 'endTime', 'alarmRules', 'alarmLevel', 'tagUnit']], // realTime
          // [['规则名称', '起效时间', '失效时间', '表达式', '预警级别', '报警单位', '缺陷次数'], ['name', 'startTime', 'endTime', 'alarmRules', 'alarmLevel', 'tagUnit', 'evaluateConut']], // defect
          // [['规则名称', '起效时间', '失效时间', '表达式', '预警级别', '报警单位', '高限', '高限死区', '高限等级', '高高限', '高高限死区', '高高限等级', '低限', '低限死区', '低限等级', '低低限', '低低限死区', '低低限等级'],
          //   ['name', 'startTime', 'endTime', 'alarmRules', 'alarmLevel', 'tagUnit', 'high', 'highDeadZone', 'highLevel', 'hhigh', 'hhighDeadZone', 'hhighLevel', 'low', 'lowDeadZone', 'lowLevel', 'llow', 'llowDeadZone', 'llowLevel']], // limitValue
          // [['规则名称', '起效时间', '失效时间', '表达式', '预警级别', '报警单位', '连续次数','幅度'], ['name', 'startTime', 'endTime', 'alarmRules', 'alarmLevel', 'tagUnit', 'evaluateConut','Increase']], // continuity
        ];
        let sheetList = {
          continued: [
            [
              "规则名称",
              "起效时间",
              "失效时间",
              "表达式",
              "预警级别",
              "报警单位",
              "趋势状态",
              "持续时间",
            ],
            [
              "name",
              "startTime",
              "endTime",
              "alarmRule",
              "alarmLevel",
              "tagUnit",
              "dataState",
              "timeLength",
            ],
          ], // continuity
          realTime: [
            [
              "规则名称",
              "起效时间",
              "失效时间",
              "表达式",
              "预警级别",
              "报警单位",
            ],
            [
              "name",
              "startTime",
              "endTime",
              "alarmRule",
              "alarmLevel",
              "tagUnit",
            ],
          ], // realTime
          defect: [
            [
              "规则名称",
              "起效时间",
              "失效时间",
              "表达式",
              "预警级别",
              "报警单位",
              "缺陷次数",
            ],
            [
              "name",
              "startTime",
              "endTime",
              "alarmRule",
              "alarmLevel",
              "tagUnit",
              "evaluateConut",
            ],
          ], // defect
          continuity: [
            [
              "规则名称",
              "起效时间",
              "失效时间",
              "表达式",
              "预警级别",
              "报警单位",
              "连续次数",
              "幅度",
            ],
            [
              "name",
              "startTime",
              "endTime",
              "alarmRule",
              "alarmLevel",
              "tagUnit",
              "evaluateConut",
              "Increase",
            ],
          ], // continuity
          limitValue: [
            [
              "规则名称",
              "起效时间",
              "失效时间",
              "表达式",
              "预警级别",
              "报警单位",
              "高限",
              "高限死区",
              "高限等级",
              "高高限",
              "高高限死区",
              "高高限等级",
              "低限",
              "低限死区",
              "低限等级",
              "低低限",
              "低低限死区",
              "低低限等级",
            ],
            [
              "name",
              "startTime",
              "endTime",
              "alarmRule",
              "alarmLevel",
              "tagUnit",
              "high",
              "highDeadZone",
              "highLevel",
              "hhigh",
              "hhighDeadZone",
              "hhighLevel",
              "low",
              "lowDeadZone",
              "lowLevel",
              "llow",
              "llowDeadZone",
              "llowLevel",
            ],
          ], // limitValue
        };
        // 文件名称
        let excelTitleName = "模型数据";
        // sheet名称
        let sheetName = ["模型"];
        // using启用
        // 获取所有的rulesType
        for (const value of this.modalData) {
          sheetName.push(value.rulesType);
          list[0].push([
            value.name,
            value.using,
            value.userName,
            value.saveHisData,
            value.rulesType,
          ]);
          // 判断rulesType
          switch (value.rulesType) {
            case "continued":
              addContinuedList(value);
              list.push(sheetList[value.rulesType]);
              break;
            case "realTime":
              addRealTimeList(value);
              list.push(sheetList[value.rulesType]);
              break;
            case "defect":
              addDefectList(value);
              list.push(sheetList[value.rulesType]);
              break;
            case "continuity":
              addContinuityList(value);
              list.push(sheetList[value.rulesType]);
              break;
            case "limitValue":
              addLimitValueList(value);
              list.push(sheetList[value.rulesType]);
              break;
          }
        }

        // continued
        function addContinuedList(obj) {
          let ind = [];
          obj.alarmRules.forEach((val, index) => {
            sheetList[obj.rulesType].push([
              val.name,
              val.startTime,
              val.endTime,
              val.condition,
              val.alarmLevel,
              val.tagUnit,
              val.dataState,
              val.timeLength,
            ]);
            ind.push(sheetList[obj.rulesType].length);
          });
          list[0][list[0].length - 1].push(ind.join(";"));
        }

        // realTime
        function addRealTimeList(obj) {
          let ind = [];
          obj.alarmRules.forEach((val, index) => {
            sheetList[obj.rulesType].push([
              val.name,
              val.startTime,
              val.endTime,
              val.alarmRule,
              val.alarmLevel,
              val.tagUnit,
            ]);

            ind.push(sheetList[obj.rulesType].length);
          });
          list[0][list[0].length - 1].push(ind.join(";"));
        }

        // defect
        function addDefectList(obj) {
          let ind = [];
          obj.alarmRules.forEach((val, index) => {
            sheetList[obj.rulesType].push([
              val.name,
              val.startTime,
              val.endTime,
              val.alarmRule,
              val.alarmLevel,
              val.tagUnit,
              val.evaluateConut,
            ]);
            ind.push(sheetList[obj.rulesType].length);
          });
          list[0][list[0].length - 1].push(ind.join(";"));
        }

        // continuity
        function addContinuityList(obj) {
          let ind = [];

          obj.alarmRules.forEach((val, index) => {
            sheetList[obj.rulesType].push([
              val.name,
              val.startTime,
              val.endTime,
              val.alarmRule,
              val.alarmLevel,
              val.tagUnit,
              val.evaluateConut,
              val.Increase,
            ]);
            ind.push(sheetList[obj.rulesType].length);
          });
          list[0][list[0].length - 1].push(ind.join(";"));
        }

        // limitValue
        function addLimitValueList(obj) {
          let ind = [];
          obj.alarmRules.forEach((val, index) => {
            sheetList[obj.rulesType].push([
              val.name,
              val.startTime,
              val.endTime,
              val.alarmRule,
              val.alarmLevel,
              val.tagUnit,
              val.high,
              val.highDeadZone,
              val.highLevel,
              val.hhigh,
              val.hhighDeadZone,
              val.hhighLevel,
              val.low,
              val.lowDeadZone,
              val.lowLevel,
              val.llow,
              val.llowDeadZone,
              val.llowLevel,
            ]);
            ind.push(sheetList[obj.rulesType].length);
          });
          list[0][list[0].length - 1].push(ind.join(";"));
        }

        this.noRepeat(sheetName);
        this.exportExcel_sheet(list, excelTitleName, sheetName);
      }
    },
    // 导出测点
    async exportPointExcel() {
      if (!this.dataTree[0].children) {
        this.$Message.error("未添加节点!!!");
      } else {
        let tableData = [
          {
            name: "节点名称",
            fatherP: "父节点",
            nameP0: "点名称",
            nameP1: "…",
          },
        ];
        let excelValue = ["name", "fatherP", "nameP0", "nameP1"];
        // 获取所有节点树
        // console.log(this.dataTree)
        // 获取所有的节点的id和title
        let allDataTreeItem = [];
        let getPitchPoint = function (data, arr) {
          for (let item of data) {
            arr.push({
              title: item.title,
              id: item.id,
              parent_id: item.parent_id,
            });
            if (item.children.length) getPitchPoint(item.children, arr);
          }
          return arr;
        };
        getPitchPoint(this.dataTree, allDataTreeItem);
        // 查找父级的title
        let getParentTitle = function (data, current) {
          let result = null;
          for (const k in data) {
            if (result !== null) break;
            let item = data[k];
            if (item.id == current) {
              result = item.title;
              break;
            } else if (item.children.length) {
              result = getParentTitle(item.children, current);
            }
          }
          return result;
        };
        // 相对的点名称
        for (const value of allDataTreeItem) {
          let childObj = {
            name: value.title,
            fatherP: getParentTitle(this.dataTree, value.parent_id) || "root",
          };
          let res = await this.getMeasuringPoint_Excel(value.id);
          console.log(res);
          res.forEach((value, index) => {
            this.$set(childObj, `nameP${index}`, value.name);
            excelValue.push(`nameP${index + 2}`);
          });
          tableData.push(childObj);
        }
        this.exportExcel(this.noRepeat(excelValue), tableData);
      }
    },
    // 获取测点
    getMeasuringPoint_Excel(itemID) {
      let data = {
        head: "alarmCenter",
        message: {
          head: "tag",
          message: {
            head: "getByItemId",
            message: {
              itemId: itemID,
            },
          },
        },
      };
      return new Promise((resolved) => {
        this.$store.state.system.$.dbCom.sendMessage(data, (err, res) => {
          resolved(res);
        });
      });
    },
    // 导出模型的方法
    exportExcel_sheet(list, title, sheetName) {
      require.ensure([], () => {
        const {
          export_json_to_excel_sheet,
        } = require("../../assets/exportExcel/Export2Excel");
        export_json_to_excel_sheet(list, title, sheetName);
      });
    },
    //导出测点的方法
    exportExcel(excelValue, excelData) {
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../assets/exportExcel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "导入方式",
          "new",
          "说明",
          "new为重建点结构，add为新增节点",
        ]; // 设置Excel的表格第一行的标题
        const data = this.formatJson(excelValue, excelData); //把要导出的数据存到list,上面的index、nickName、name是对象的属性key值
        export_json_to_excel(tHeader, data, "测点目录"); //最后一个是表名字
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // ***********************************导出Excel end***********************************
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
            position: "relative",
          },
        },
        [
          h(
            "span",
            {
              style: {
                lineHeight: "24px",
                display: "inline-block",
              },
            },
            [
              h("Icon", {
                props: {
                  type: "ios-folder-outline",
                },
                style: {
                  marginRight: "3px",
                  fontSize: "16px",
                  marginTop: "5px",
                },
              }),
              h(
                "span",
                {
                  class: {
                    "ivu-tree-title": true,
                  },
                  style: {
                    fontSize: "12px",
                  },
                  on: {
                    click: (e) => {
                      if (this.oldSelectNode) {
                        this.oldSelectNode.className = "ivu-tree-title";
                      }
                      event.target.className =
                        "ivu-tree-title ivu-tree-title-selected";
                      this.oldSelectNode = event.target;
                      this.onTreeData = data;
                      this.changeData(data);
                    },
                    contextmenu: (e) => {
                      this.nodeTreeId = data.id;
                      this.nodeTreePrent = data.childrenId;
                      this.nodeTreePrent_id = data.parent_id;
                      this.nodeTreeTitle = data.title;
                      e.preventDefault();
                      this.$refs.localMenu.$refs.reference = event.target;
                      this.$refs.localMenu.currentVisible = !this.$refs
                        .localMenu.currentVisible;
                    },
                  },
                },
                data.title
              ),
            ]
          ),
        ]
      );
    },
    /*************************************  报警模型 **************************************/
    onAlarmLevel(data) {
      if (data == -1) {
        this.enhanceAlarmLevelList = true;
        this.alarmLevelList = false;
      } else {
        this.enhanceAlarmLevelList = false;
        this.alarmLevelList = true;
      }
    },
    /**
     * 选中表达式框
     * 参数 下标
     */
    onFocus(data) {
      this.condition = -9999;
      this.signNumber = data;
      this.isButtGroup = true;
    },
    /**
     * 选中表达式框（趋势）
     * 参数 下标
     */
    onFocus1(data) {
      this.condition = data;
      this.signNumber = -9999;
      this.isButtGroup = true;
    },
    /**
     *
     */
    onBlur(data) {
      this.isButtGroup = true;
    },
    onModelEdit(type) {
      if (type == "model") {
        if (this.openModelType != "add") {
          this.openModelType = "edit";
        }
      } else {
        this.openRuleType = "edit";
      }
    },
    /**
     * 双击推拉框的 表格
     * 参数 name
     */
    onDblData(data) {
      var dataName = "[" + data.name + "].PV";
      if (this.signNumber != -9999) {
        this.objList.alarmRule += "[" + data.name + "].PV";
      } else if (this.condition != -9999) {
        this.objList.condition += "[" + data.name + "].PV";
        this.objList.alarmRule = "@趋势@";
      } else {
        console.error("没有交互表达式！！！");
      }
      this.openTable = false;
    },
    //双击节点目录
    onDblDataList() {
      var dataName = "{" + this.nodeTreeTitle + "}";
      this.objList.alarmRule = dataName;
      this.openTable = false;
    },
    /**
     * 点击父节点  菜单
     * 参数 node 节点
     */
    menuParents(data, value) {
      this.isQuery = false;
      if (!data) {
        return;
      }

      this.openModelType = "edit";
      //隐藏模型添加按钮
      this.addButton = "rule";
      this.currentEdit = new Proxy(
        new model(this.onModelEdit, this.getModelData[data.row._id]),
        {
          set: function (target, key, value) {
            target.onModelEdit("model");
            target[key] = value;
            return true;
          },
        }
      );
      //打开规则表格
      this.showRule = true;
      this.ajaxHistoryData2 = this.currentEdit.getAlarmRules();
      this.dataCountRule = this.ajaxHistoryData2.length;
      //如果规则等于0 可以修改类型
      if (this.currentEdit.alarmRules == 0) {
        this.isDisabled = false; //反选值时候不可 更改规则
      } else {
        this.isDisabled = true; //反选值时候不可 更改规则
      }
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.dataCountRule < this.pageSizeRule) {
        this.ruleData = this.ajaxHistoryData2;
      } else {
        this.ruleData = this.ajaxHistoryData2.slice(0, this.pageSizeRule);
      }
      if (value != "no") {
        //打开报警模型
        this.showModel = true;
      }
    },
    /**
     * 编辑按钮
     */
    onEdit(value) {
      this.isQuery = false;
      // this.openModelType = "edit";
      if (value.alarmLevel == -1) {
        this.enhanceAlarmLevelList = true;
        this.alarmLevelList = false;
      } else {
        this.enhanceAlarmLevelList = false;
        this.alarmLevelList = true;
      }
      this.onRuleType(this.currentEdit.rulesType, value);
      this.isDisabled = true;
      this.showRule = false;
      //隐藏模型添加按钮
      this.addButton = "rule";
    },
    /**
     *点击软键盘
     * 参数 值
     */
    upKey(value) {
      //判断表达式
      if (this.signNumber != -9999) {
        this.objList[this.signNumber].alarmRule += value;
      }
      //判断趋势
      if (this.condition != -9999) {
        this.objList[this.condition].condition += value;
      }
    },
    /*
     * 移除新增规则
     * 参数标识
     */
    delRule(data) {
      //删除对应的规则
      this.subModel("delrule", data);
    },
    /**
     * 新增模型
     */
    addNodes() {
      this.currentEdit = new Proxy(
        new model(this.onModelEdit, {
          userName: this.$store.state.system.$.userName,
          rulesType: "limitValue",
        }),
        {
          set: function (target, key, value) {
            target.onModelEdit("model");
            target[key] = value;
            return true;
          },
        }
      );
      this.openModelType = "add";
      this.showModel = true;
      this.isDisabled = false;
      this.objList = [];
      this.showRule = false;
      this.ruleData = [];
      this.addButton = false;
      this.addRule();
    },
    /**
     * 添加报警类型
     */
    addRule() {
      this.isOpenRuleType = "add";
      this.showRule = false;
      this.onRuleType(this.currentEdit.rulesType);
    },
    //验证输入框是否有值 添加样式
    ModelTestingName(value, _id) {
      if (value == "") {
        document.getElementById(_id).classList.add("bulrColor");
      } else {
        document.getElementById(_id).classList.remove("bulrColor");
      }
    },
    /** 提交模型 , 修改模型，删除规则 */
    async subModel(value, values) {
      if (!this.showRule) {
        return this.$Message.error("请关闭正在编辑的规则窗口");
      }
      if (value == "delrule") {
        this.ruleData.splice(values.index, 1);
        //删除原数组
        for (var k in this.ajaxHistoryData2) {
          if (this.ajaxHistoryData2[k].id == values.id) {
            this.ajaxHistoryData2.splice(k, 1);
          }
        }
        this.openModelType = "edit";
      }
      this.currentEdit.alarmRules = this.ruleData;
      var result = await this.isLegitimate(false, false);
      if (this.openModelType == "") {
        return;
      }
      if (result) {
        return this.$Message.error(result);
      }

      var data = {};
      if (this.openModelType == "add") {
        data = {
          head: "alarmCenter",
          message: {
            head: "model",
            message: {
              head: "save",
              message: {
                name: this.currentEdit.name, //模型名称
                desc: this.currentEdit.desc,
                using: this.currentEdit.using ? false : true, //启用状态
                updateTime: new Date(),
                userName: this.currentEdit.userName, //模版更新人
                rulesType: this.currentEdit.rulesType, //规则类型,
                alarmRules: this.ajaxHistoryData2, //规则数组
                sights: this.currentEdit.sights, // 测点属性
              },
            },
          },
        };
      } else {
        data = {
          head: "alarmCenter",
          message: {
            head: "model",
            message: {
              head: "updata",
              message: {
                _id: this.currentEdit._id,
                name: this.currentEdit.name, //模型名称
                desc: this.currentEdit.desc,
                using: this.currentEdit.using ? false : true, //启用状态
                updateTime: new Date(),
                userName: this.currentEdit.userName, //模版更新人
                rulesType: this.currentEdit.rulesType, //规则类型,
                alarmRules: this.ajaxHistoryData2, //规则数组
                sights: this.currentEdit.sights, // 测点属性
              },
            },
          },
        };
      }
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (err) {
          this.$Message.error("保存/更新失败，错误请查看服务端日志");
        } else if (result) {
          this.openModelType = "";
          this.openRuleType = "";
          if (value == "delrule") {
            this.$Message.info("删除成功！");
          } else {
            this.$Message.info("添加成功");
          }
          this.tagListJosn = {};
          this.getModeAll();
          this.getListData();
        }
      });
    },
    /** 保存规则列表 */
    async subRuleList() {
      this.isOnRule = true;
      var result = await this.isLegitimate(false, true);
      if (result) {
        return this.$Message.error(result);
      }
      this.objList.startTime = this.localTime(this.objList.startTime);
      this.objList.endTime = this.localTime(this.objList.endTime);

      var data = {};
      for (var k in this.objList) {
        var str = this.objList[k];
        if (k != "saveHisData") {
          var n = Number(str);
          if (!isNaN(n)) {
            data[k] = isNaN(parseFloat(this.objList[k]))
              ? ""
              : parseFloat(this.objList[k]);
          } else {
            data[k] = this.objList[k];
          }
        } else {
          data[k] = this.objList[k];
        }
      }
      var isHas = false;

      if (this.isOpenRuleType == "add") {
        for (var i = 0; i < this.ruleData.length; i++) {
          if (this.ruleData[i].id == data.id) {
            isHas = true;
          }
        }
        if (!isHas) {
          //存储原始数据用于 存储修改

          this.ajaxHistoryData2.push(data);

          this.ruleData = this.ajaxHistoryData2;

          this.isOpenRuleType = "edit";
        } else {
          this.$Message.info("已有相同名称的规则存在，请修改规则名称");
        }
      } else {
        //存储原始数据用于 存储修改
        for (var k in this.ajaxHistoryData2) {
          if (this.ajaxHistoryData2[k].id == data.id) {
            this.ajaxHistoryData2.splice(k, 1, data);
          }
        }
        //保存列表
        for (var i = 0; i < this.ruleData.length; i++) {
          if (this.ruleData[i].id == data.id) {
            this.ruleData.splice(i, 1, data);
            break;
          }
        }
      }
      this.$Message.info("添加成功");
    },
    localTime(UTCDateString) {
      if (!UTCDateString) {
        return "-";
      }

      function formatFunc(str) {
        //格式化显示
        return str > 9 ? str : "0" + str;
      }

      var date2 = new Date(UTCDateString); //这步是关键
      var year = date2.getFullYear();
      var mon = formatFunc(date2.getMonth() + 1);
      var day = formatFunc(date2.getDate());
      var hour = date2.getHours();
      hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes());
      var second = formatFunc(date2.getSeconds());
      var dateStr =
        year +
        "-" +
        mon +
        "-" +
        day +
        " " +
        hour +
        ":" +
        min +
        ":" +
        "" +
        second;
      return dateStr;
    },
    async messageBox() {
      return new Promise((resolved, rejected) => {
        this.$Modal.confirm({
          title: "系统",
          content: "<p>是否放弃本次添加/修改</p>",
          onOk: () => {
            resolved(true);
          },
          onCancel: () => {
            resolved(false);
          },
        });
      });
    },
    /**
     * 关闭模型
     */
    async closeModel() {
      this.isQuery = false;
      if (this.openModelType == "edit") {
        var result = await this.messageBox();
        if (result) {
          this.subModel();
          //关闭时候更新下数据 在更新数据同时有关闭模型

          this.changeData(this.onTreeData);
        }
      }
      this.dataCountRuleCurrent = 1;
      this.showModel = false;
      this.addButton = "model";
      this.currentEdit = new model(this);
      this.openModelType = "";
      this.openRuleType = "";
      this.ajaxHistoryData2 = [];
    },
    //验证输入框是否有值 添加样式
    ModelTestingName(value, _id) {
      if (value == "") {
        document.getElementById(_id).classList.add("bulrColor");
      } else {
        document.getElementById(_id).classList.remove("bulrColor");
      }
    },
    /**
     * 检查模型数据是否合法
     */
    async isLegitimate(type, data) {
      if (data) {
        return await this.objList.getError(type, this);
      } else {
        return await this.currentEdit.getError(type, this);
      }
    },
    /**删除模型 */
    delNodes(value) {
      if (value != undefined) {
        var data = {
          head: "alarmCenter",
          message: {
            head: "model",
            message: {
              head: "del",
              message: {
                _id: value.row._id,
                name: value.row.name,
              },
            },
          },
        };
        this.$Modal.confirm({
          title: "是否删除？",
          onOk: () => {
            this.$store.state.system.$.dbCom.sendMessage(
              data,
              (err, result) => {
                if (err) {
                  console.log(err);
                  this.$Message.error("删除失败！");
                } else if (result) {
                  this.$Message.info("删除成功！");
                  //this.addNodes();
                  this.getModeAll();
                  this.tagListJosn = {};
                  this.getListData();
                }
              }
            );
          },
        });
      }
    },
    /************************************** 测点目录   ***********************************/
    /**根据点名筛选 */
    querySpot() {
      if (this.spotName != "") {
        this.columnsData = [];
        this.queryName = this.spotName;
        this.queryDescName = "";
        this.getAllData();
        this.start = 0;
        //     var data = [];
        //     for(var k in this.columnsData){
        //         if(this.columnsData[k].NAME.indexOf(this.spotName)>-1){
        //             data.push(this.columnsData[k])
        //         }
        //     }
        //     console.log(this.spotName)
        //     this.columnsData = data;
        // }else{
        //     this.columnsData = this.allData;
      }
    },
    /**根据点描述筛选 */
    queryDesc() {
      if (this.descName != "") {
        this.columnsData = [];
        this.queryName = "";
        this.queryDescName = this.descName;
        this.getAllData();
        this.start = 0;
        //     var data = [];
        //     for(var k in this.columnsData){
        //         if(this.columnsData[k].DESC.indexOf(this.descName)>-1){
        //             data.push(this.columnsData[k])
        //         }
        //     }
        //     this.columnsData = data;
        // }else{
        //     this.columnsData = this.allData;
      }
    },
    //存储表格的数据 获取选中数据
    onTable(data) {
      this.onTableData = data;
    },
    //删除点
    onDelSpot(row) {
      var data = {
        head: "alarmCenter",
        message: {
          head: "tag",
          message: {
            head: "del",
            message: {
              id: row._id,
            },
          },
        },
      };
      this.$Modal.confirm({
        title: "是否删除？",
        onOk: () => {
          this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
            if (err) {
              console.log(err);
              this.$Message.error("删除失败！");
            } else if (result) {
              this.$Message.info("删除成功！");
              //更新下数据表
            }
          });
          //更新表单
          for (var j in this.historyData) {
            if (this.historyData[j]._id == row._id) {
              this.historyData.splice([j], 1);
            }
          }
        },
      });
    },
    //打开重命名弹窗
    noRename() {
      this.modal3 = true;
      this.nodeRename = this.nodeTreeTitle;
    },
    /**
     * 重命名 提交
     */
    onRename() {
      if (this.nodeRename == "") return this.$Message.error("命名不能为空！");
      var data = {
        head: "alarmCenter",
        message: {
          head: "actalog",
          message: {
            head: "upDataItem",
            message: {
              id: this.nodeTreePrent,
              name: this.nodeRename,
            },
          },
        },
      };
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (err) {
          this.$Message.error("重命名失败！");
        } else if (result) {
          //添加成功后 刷新树
          this.getTreeData();
          this.$Message.info("重命名成功！");
        }
      });
    },
    //点击增加点按钮
    spotAddButton() {
      //清空选中的
      this.$refs.selectionSpot.selectAll(false);
      if(this.nodeTreePrent=="无数据"){
          this.$Message.error("请新增树节点在添加点！");
          return;
      };
      if (this.nodeTreePrent == undefined) {
        this.$Message.error("请选择树节点在添加点！");
        return;
      } else {
        this.modal4 = true;
        //清空筛选
        this.queryName = ""; //查询点  input
        this.queryDescName = ""; //添加点描述  input
        //请空输入框
        this.spotName = "";
        this.descName = "";
        this.columnsData = [];
        this.getAllData();
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        // 当滚动条从没有到有时，不加setTimeout滚动条将不会滚动到底部
        setTimeout(() => {
          let overflowY = this.$el.getElementsByClassName("ivu-table-body")[0];
          if (!overflowY) {
            return;
          }
          overflowY.scrollTop = overflowY.scrollHeight + 34;
        }, 500);
      });
    },
    //新增表格选中 新增点
    onSelect(row) {
      this.selectRowList = row;
    },
    /**
     * 新增点 确定
     */
    onAddSpot() {
      var result = this.selectRowList;
      for (var i = 0; i < result.length; i++) {
        var data = {
          head: "alarmCenter",
          message: {
            head: "tag",
            message: {
              head: "add",
              message: {
                name: result[i].NAME,
                desc: result[i].DESC,
                itemId: this.nodeTreeId,
              },
            },
          },
        };
        this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
          if (err) {
            console.log(err);
            this.$Message.error("点增加失败");
          } else if (result) {
            this.handleListApproveHistory(this.nodeTreeId);
          }
        });
      }
    },
    /**
     * 新增节点 tree
     */
    onAddNode() {
      //判断添加节点是否是空
      if (this.newNode != "") {
        if (this.nodeTreePrent == "无数据") {
          var data = {
            head: "alarmCenter",
            message: {
              head: "actalog",
              message: {
                head: "addRoot",
                message: {
                  parent: "root",
                  name: this.newNode,
                  children: [],
                },
              },
            },
          };
        } else {
          var data = {
            head: "alarmCenter",
            message: {
              head: "actalog",
              message: {
                head: "addItem",
                message: {
                  parent: this.nodeTreePrent,
                  name: this.newNode,
                },
              },
            },
          };
        }
        this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
          if (err) {
            console.log(err);
            this.$Message.error("节点增加失败！");
          } else if (result) {
            //添加成功后 刷新树
            this.getTreeData();
            this.$Message.info("添加成功！");
            this.newNode = "";
          }
        });
      }
    },
    /**
     * 删除节点
     */
    onDelNode() {
      if (this.nodeTreePrent != undefined) {
        var data = {
          head: "alarmCenter",
          message: {
            head: "actalog",
            message: {
              head: "deleteItem",
              message: {
                id: this.nodeTreePrent,
                parent: this.nodeTreePrent_id,
              },
            },
          },
        };
        this.$Modal.confirm({
          title: "是否删除？",
          onOk: () => {
            this.$store.state.system.$.dbCom.sendMessage(
              data,
              (err, result) => {
                if (err) {
                  console.log(err);
                  this.$Message.error("删除失败！");
                } else if (result) {
                  //添加成功后 刷新树
                  this.getTreeData();
                  this.$Message.info("删除成功！");
                }
              }
            );
          },
        });
      } else {
        this.$Message.error("未选择重名节点！");
      }
    },
    /**
     * 切换报警类型
     */
    onRuleType(value, data) {
      this.imgModelHelp = require("../../assets/Help/" + value + ".gif");
      this.showRuleType = value;
      this.objList = new Proxy(
        new ruleClass[value](this.onModelEdit, data ? data : {}),
        {
          set: function (target, key, value) {
            target.onModelEdit("rule");
            target[key] = value;
            return true;
          },
        }
      );
      if (this.objList.id) {
        this.objList.id = this.objList.id;
      } else {
        this.objList.id =
          (Math.random() * 10000000).toString(16).substr(0, 4) +
          "-" +
          new Date().getTime() +
          "-" +
          Math.random().toString().substr(2, 5);
      }
    },
    //关闭 帮助
    closeHelp() {
      this.isHelp = false;
      this.isModelHelp = false;
      this.isTreeHelp = false;
    },
    //获取点击标签页的标号
    onTabs(name) {
      this.isOnRule = false;
      if (this.showModel) {
        this.closeModel();
      }
      if (name == 0) {
        this.addButton = "tag";
        this.imgHelp = require("../../assets/Help/测点.gif");
      } else if (name == 1) {
        this.addButton = "model";
        this.imgHelp = require("../../assets/Help/模型.gif");
        this.getListData();
      } else if (name == 2) {
        this.addButton = "rule";
        this.imgHelp = require("../../assets/Help/数据.gif");
        this.getDateList();
      }
      this.isQuery = false;
      this.tabsNumber = name;
    },
    async setTagList() {
      return await new Promise((resolved) => {
        var testData = this.tagListJosn[this.nodeTreeTitle];
        this.ajaxHistoryData = testData.histories;
        this.dataCount = testData.histories.length;
        this.tableData1 = this.ajaxHistoryData.slice(0, this.pageSize);
        // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
        if (testData.histories.length < this.pageSize) {
          this.historyData = this.ajaxHistoryData;
        } else {
          this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
        }
        resolved();
      });
    },
    //点击树后获取获取模型列表数据
    async getListData() {
      this.spinShow = true;
      setTimeout(async () => {
        this.historyData = [];
        this.ajaxHistoryData = [];
        if (this.tagListJosn[this.nodeTreeTitle]) {
          await this.setTagList();
          if (this.tabsNumber == 1) {
            this.setModeData();
          }
          this.spinShow = false;
        } else {
          await this.handleListApproveHistory(this.nodeTreeId);
          if (this.tabsNumber == 1) {
            this.setModeData();
          }
          this.spinShow = false;
        }
      }, 100);
    },
    setModeData() {
      var res = this.modalData;
      this.getModelData = {};
      for (var i = 0; i < res.length; i++) {
        this.getModelData[res[i]._id] = res[i];
      }
      var list = [];
      for (var k = 0; k < this.ajaxHistoryData.length; k++) {
        list.push("[" + this.ajaxHistoryData[k].name + "]");
      }
      //获取二级菜单
      this.ajaxHistoryData1 = this.alarmrulseEx(res, this.nodeTreeTitle, list);
      // this.ajaxHistoryData1 = this.alarmrulseEx(res,this.nodeTreeTitle,this.ajaxHistoryData);

      for (var i in this.ajaxHistoryData1) {
        this.ajaxHistoryData1[i].rulesShowType = model.getTypeStr(
          this.ajaxHistoryData1[i].rulesType
        );
      }
      this.dataCountModel = this.ajaxHistoryData1.length;

      if (this.dataCountModel < this.pageSizeModel) {
        this.modelData = this.ajaxHistoryData1;
      } else {
        this.modelData = this.ajaxHistoryData1.slice(0, this.pageSizeModel);
      }
    },
    async getModeAll() {
      var datas = {
        head: "alarmCenter",
        message: {
          head: "model",
          message: {
            head: "get",
          },
        },
      };
      return new Promise((resolved) => {
        this.$store.state.system.$.dbCom.sendMessage(datas, (err, res) => {
          this.modalData = res;
          resolved();
          if (err) {
            this.$Message.error(err);
            this.spinShow = false;
          }
        });
      });
    },
    //筛选 自定义菜单
    alarmrulseEx(att, catalogName, tagNames) {
      var catalogNames = "{" + catalogName + "}";
      var arr = [];
      for (var i = 0; i < att.length; i++) {
        for (var j = 0; j < att[i].alarmRules.length; j++) {
          //判断规则类型
          if (
            att[i].alarmRules[j].condition != undefined &&
            att[i].alarmRules[j].condition != ""
          ) {
            if (
              att[i].alarmRules[j].condition.substring(
                0,
                att[i].alarmRules[j].condition.length - 3
              ) == catalogNames
            ) {
              arr.push(att[i]);
              break;
            }
            if (
              tagNames.indexOf(
                att[i].alarmRules[j].condition.substring(
                  att[i].alarmRules[j].condition.indexOf("["),
                  att[i].alarmRules[j].condition.indexOf("]") + 1
                )
              ) >= 0
            ) {
              arr.push(att[i]);
              break;
            }
          }
          //if(att[i].alarmRules[j].alarmRule == catalogNames){
          if (
            att[i].alarmRules[j].alarmRule.substring(
              att[i].alarmRules[j].alarmRule.indexOf("{"),
              att[i].alarmRules[j].alarmRule.indexOf("}") + 1
            ) == catalogNames
          ) {
            arr.push(att[i]);
            break;
          }
          var isHas = false;
          if (
            tagNames.indexOf(
              att[i].alarmRules[j].alarmRule.substring(
                att[i].alarmRules[j].alarmRule.indexOf("["),
                att[i].alarmRules[j].alarmRule.indexOf("]") + 1
              )
            ) >= 0
          ) {
            arr.push(att[i]);
            isHas = true;
            break;
          }

          if (isHas) break;
        }
      }
      return this._uniq(arr);
    },
    //对象去重
    _uniq(arr) {
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i]._id]) {
          if (arr[i].using == "启用") {
            arr[i].using = true;
          } else if (arr[i].using == "停用") {
            arr[i].using = false;
          }
          //arr[i].rulesType = this.translationChinese(arr[i].rulesType);
          result.push(arr[i]);
          obj[arr[i]._id] = true;
        }
      }
      return result;
    },
    //点击树  树节点数据
    changeData(data) {
      //$scope.$broadcast this.$store.state.system.$.dbCom
      if (data == undefined) return;
      if (data.length == 0) return;
      this.nodeTreeId = data.id;
      this.nodeTreePrent = data.childrenId;
      this.nodeTreePrent_id = data.parent_id;
      this.nodeTreeTitle = data.title;
      //根据标签标号来判断是测点目录还是报警模型
      if (this.tabsNumber == 0) {
        this.menuShow = false;

        this.addButton = "tag"; //测点悬浮按钮显隐

        this.getListData(); //获取模型列表
      } else if (this.tabsNumber == 1) {
        //点击树几点操作报警模型
        this.menuShow = true;
        this.addButton = "model"; //测点悬浮按钮显隐
        //关闭规则
        this.showModel = false;
        this.historyData = [];

        this.getListData(); //获取模型列表
      } else {
        console.log("其他");
      }
    },
    // 关闭规则
    async colseRule() {
      this.isQuery = false;
      if (this.openRuleType == "edit") {
        var result = await this.isLegitimate(true, true);
        if (result) {
          return this.$Message.error(result);
        } else {
          this.showRule = true;
          this.isButtGroup = true;

          //更新规则列表
          this.addButton = "rule";
        }
      } else {
        this.showRule = true;
        this.isButtGroup = true;

        //更新规则列表
        this.addButton = "rule";
      }
      if (this.ruleData.length < 1) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
      this.objList = new limitValue(this.currentEdit);
      this.openRuleType == "";
    },
    //登陆后打开窗口
    show: function (isShow, key, name) {
      //登录名称
      this.loginName = name;
      this.isShow = isShow ? true : false;
      if (this.isShow) {
        var url = window.location.href.replace(/:[0-9].*$/, ":3170");
        url += "?key=";
        url += key;
        this.treeStyleNode = {
          height: innerHeight + "px",
          border: "1px solid #dcdee2",
        };
        this.getModeAll();
        this.getTreeData();
        this.getAllData();
      }
    },
    //退出登录
    tologin: function () {
      this.$store.state.system.$.LogOut();
    },
    //点击展开表格
    isOpenTable: function () {
      //判断是否点击过树， 查询数据
      if (this.signNumber != -9999 || this.condition != -9999) {
        this.openTable = true;
      } else {
        if (this.tableData1.length == 0) {
          this.$Message.info("没有选择节点！");
        } else if (this.signNumber == -9999 || this.condition == -9999) {
          this.$Message.info("没有选中交互框！");
        }
      }
    },
    // 获取历史记录信息  查询表格
    async handleListApproveHistory(itemId) {
      let data = {
        head: "alarmCenter",
        message: {
          head: "tag",
          message: {
            head: "getByItemId",
            message: {
              itemId: itemId,
            },
          },
        },
      };
      return new Promise((resolved) => {
        this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
          if (err) {
            this.$Message.error(err);
          } else {
            var testData = { histories: result };
            this.tagListJosn[this.nodeTreeTitle] = testData;
            // 保存取到的所有数据
            this.ajaxHistoryData = this.removerDollar(
              testData.histories,
              "name"
            );
            this.dataCount = testData.histories.length;
            this.tableData1 = this.ajaxHistoryData.slice(0, this.pageSize);
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (testData.histories.length < this.pageSize) {
              this.historyData = this.ajaxHistoryData;
            } else {
              this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
            }
            resolved();
          }
        });
      });
    },
    //加载更多
    loadMoreTag() {
      var page = this.tableData1.length + this.pageSize;
      this.tableData1 = this.ajaxHistoryData.slice(0, page);
      if (page > this.ajaxHistoryData.length) {
        this.loading1 = false;
      }
    },
    //点击翻页
    changepage(index) {
      this.dataCountCurrent = index;
      var _start = (index - 1) * this.pageSize;
      var _end = index * this.pageSize;
      this.historyData = this.ajaxHistoryData.slice(_start, _end);
    },
    //点击翻页
    changepageModel(index) {
      this.dataCountModelCurrent = index;
      var _start = (index - 1) * this.pageSizeModel;
      var _end = index * this.pageSizeModel;
      this.modelData = this.ajaxHistoryData1.slice(_start, _end);
    },
    //点击翻页
    changepageRule(index) {
      this.dataCountRuleCurrent = index;
      var _start = (index - 1) * this.pageSizeRule;
      var _end = index * this.pageSizeRule;
      this.ruleData = this.ajaxHistoryData2.slice(_start, _end);
    },
    changepageOperation(index) {
      this.operationCountCurrent = index;
      var _start = (index - 1) * this.pageSizeOperation;
      var _end = index * this.pageSizeOperation;
      this.dataOperation = this.ajaxHistoryData3.slice(_start, _end);
    },
    //获取树节点 数据
    getTreeData() {
      this.$store.state.system.$.dbCom.sendMessage(
        {
          head: "alarmCenter",
          message: {
            head: "actalog",
            message: {
              head: "load",
              message: {},
            },
          },
        },
        (err, result) => {
          if (err) {
            console.log(err);
            this.$Message.error(err);
          } else if (result) {
            //判断获取回来的数据是否是空
            if (result != undefined && JSON.stringify(result) != "{}") {
              var arr = [];
              var foro = function (result) {
                for (var p in result) {
                  if (p !== "id" && p !== "parent") {
                    arr.push({
                      title: p,
                      expand: true,
                      id: result[p].id,
                      parent: result[p].parent,
                      childrenId: result[p].id,
                      children: [],
                    });
                    foro(result[p]);
                  }
                }
                return arr;
              };
              //递归树节点
              var obj = foro(result);
              //根据递归出来的数据结构 根据childrenId来找到节点
              var res = function (parent_id, data) {
                var list = [];
                for (var i = 0, l = data.length; i < l; i++) {
                  var item = data[i];
                  if (item.parent == parent_id) {
                    item.parent_id = parent_id;
                    item.expand = false;
                    var children = res(item.childrenId, data);
                    item.children = children;
                    list.push(item);
                  }
                }
                return list;
              };
              var childrenData = res(obj[0].childrenId, obj);
              //拼接父节点
              var result = [
                {
                  title: obj[0].title,
                  selected: true,
                  expand: true,
                  id: obj[0].id,
                  children: childrenData,
                  childrenId: obj[0].childrenId,
                },
              ];
              this.dataTree = result;
              this.isAble = true;
              this.nodeTreePrent = obj[0].id;
              this.nodeTreeId = obj[0].id;
              this.nodeTreeTitle = obj[0].title;
              this.getListData();
            } else {
              var result = [
                {
                  title: "无数据请添加",
                  id: "5b556ca2f41d64198ca00001",
                  childrenId: "无数据",
                  parent: "root",
                },
              ];
              this.nodeTreePrent = "无数据";
              this.dataTree = result;
              this.isAble = false;
            }
          }
        }
      );
    },
    //分批加载
    handleReachBottom() {
      this.start = this.columnsData.length;
      this.getAllData();
    },
    //加载更多
    loadMore() {
      this.loading = true;
      this.start = this.columnsData.length;
      this.getAllData();
    },
    //查询所有点
    getAllData() {
      if (this.start) {
        this.start = this.start;
      } else {
        this.start = 0;
      }
      var data = {
        head: "alarmCenter",
        message: {
          head: "tag",
          message: {
            head: "getor",
            message: {
              start: this.start,
              count: this.count, //一次请求的条数
              name: this.queryName, //过滤的属性名称
              desc: this.queryDescName, //过滤条件，暂时仅支持 “包含”
            },
          },
        },
      };
      //获取所有的点数据
      this.$store.state.system.$.dbCom.sendMessage(
        data,
        function (err, result) {
          if (err) {
            console.log(err);
            this.$Message.error("添加点失败！");
          } else if (result) {
            if (result.length < 1000) {
              this.isLoadMore = false;
            }
            this.columnsData.push.apply(
              this.columnsData,
              this.removerDollar(result, "NAME")
            );

            this.allData.push.apply(
              this.allData,
              this.removerDollar(result, "NAME")
            );
            this.loading = false;
          }
        }.bind(this)
      );
    },
    //查询 数据表
    getDateList() {
      var data = {
        head: "alarmCenter",
        message: {
          head: "dumpmongo",
          message: {
            head: "get",
          },
        },
      };
      this.dataOperation = [];
      this.ajaxHistoryData3 = [];
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (!err) {
          for (var k in result) {
            this.ajaxHistoryData3.push({
              name: k,
              user: result[k].name,
            });
          }
          for (var i in this.ajaxHistoryData3) {
            this.ajaxHistoryData3[i].rulesShowType = model.getTypeStr(
              this.ajaxHistoryData3[i].rulesType
            );
          }
          this.operationCount = this.ajaxHistoryData3.length;
          if (this.operationCount < this.pageSizeOperation) {
            this.dataOperation = this.ajaxHistoryData3;
          } else {
            this.dataOperation = this.ajaxHistoryData3.slice(
              0,
              this.pageSizeOperation
            );
          }
          if (err) {
            this.$Message.error(err);
          }
        } else {
          console.log(err);
          this.$Message.error(err);
        }
      });
    },
    //导入模型成功调用
    importModels(response, file, fileList) {
      this.$Message.info("导入操作已完成！");
    },
    //导入点成功调用
    importSpot(response, file, fileList) {
      this.$Message.info("导入操作已完成！");
    },
    //备份
    backups() {
      let data = {
        head: "alarmCenter",
        message: {
          head: "dumpmongo",
          message: {
            head: "dump",
            message: {
              name: this.$store.state.system.$.userName,
            },
          },
        },
      };
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (!err) {
          this.dataOperation.push({
            name: result.file,
            user: result.user,
          });
        } else {
          this.$Message.error(err);
        }
      });
    },
    //恢复
    recovery(json) {
      let data = {
        head: "alarmCenter",
        message: {
          head: "dumpmongo",
          message: {
            head: "restore",
            message: {
              name: json.name,
            },
          },
        },
      };
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (!err) {
          this.$Message.info("已恢复备份: " + json.name);
        } else {
          console.log(err);
          this.$Message.error(err);
        }
      });
    },
    //删除
    deletee(json) {
      let data = {
        head: "alarmCenter",
        message: {
          head: "dumpmongo",
          message: {
            head: "del",
            message: {
              name: json.name,
            },
          },
        },
      };
      this.$store.state.system.$.dbCom.sendMessage(data, (err, result) => {
        if (!err) {
          this.dataOperation.splice(json._index, 1);
          this.$Message.info("已删除备份: " + json.name);
        } else {
          console.log(err);
          this.$Message.error(err);
        }
      });
    },
    queryButtonSpot(value) {
      this.isQuery = !this.isQuery;
      this.queryListName = value;
      if (this.queryListName == "rule") {
        document.getElementsByClassName("qStyle")[0].style.top = "225px";
      } else {
        document.getElementsByClassName("qStyle")[0].style.top = "50px";
      }
    },
    querySpot1() {
      this.querydata = [];
      if (this.queryListName == "tag") {
        for (var i = 0; i < this.ajaxHistoryData.length; i++) {
          if (
            (
              this.ajaxHistoryData[i].name + this.ajaxHistoryData[i].desc
            ).indexOf(this.searchText) >= 0
          ) {
            this.querydata.push(this.ajaxHistoryData[i]);
          }
        }
        this.historyData = this.querydata;
        this.dataCountCurrent = 1;
        this.dataCount = this.historyData.length;
        // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
        if (this.historyData.length < this.pageSize) {
          this.historyData = this.querydata;
        } else {
          this.historyData = this.querydata.slice(0, this.pageSize);
        }
      } else if (this.queryListName == "model") {
        for (var i = 0; i < this.ajaxHistoryData1.length; i++) {
          if (
            (
              this.ajaxHistoryData1[i].name + this.ajaxHistoryData1[i].desc
            ).indexOf(this.searchText) >= 0
          ) {
            this.querydata.push(this.ajaxHistoryData1[i]);
          }
        }
        this.modelData = this.querydata;
        this.dataCountModelCurrent = 1;
        if (this.modelData.length < this.pageSizeModel) {
          this.modelData = this.modelData;
        } else {
          this.modelData = this.modelData.slice(0, this.pageSizeModel);
        }
      } else if (this.queryListName == "rule") {
        for (var i = 0; i < this.ajaxHistoryData2.length; i++) {
          if (this.ajaxHistoryData2[i].name.indexOf(this.searchText) >= 0) {
            this.querydata.push(this.ajaxHistoryData2[i]);
          }
        }
        this.ruleData = this.querydata;
        this.dataCountRuleCurrent = 1;
        // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
        if (this.ruleData.length < this.pageSizeRule) {
          this.ruleData = this.ruleData;
        } else {
          this.ruleData = this.ruleData.slice(0, this.pageSizeRule);
        }
      }
      this.isQuery = false;
      this.searchText = "";
    },
  },
  created() {
    //挂载
  },
};
</script>

<style>
.loadMoreStyle {
  text-align: center;
  width: 100%;
}

.treeNodeStyle {
  background: #eef3fa;
  border-bottom: 1px solid #ccc;
  text-align: left;
  height: 32px;
  font-size: 20px;
  line-height: 32px;
  color: #2d8cf0;
  padding-left: 10px;
}

.exit {
  padding: 0 8px;
  color: #ed4014;
  font-size: 24px;
}

.exit:hover {
  cursor: pointer;
  color: #f16643;
}

.modelList {
  position: absolute;
  top: 0px;
  background: #fff;
  width: 100%;
  height: 100%;
}

.isShow {
  display: none;
}

.treeStyle {
  width: 15%;
  text-align: left;
  height: 100%;
  padding-left: 15px;
}

.ruleStyle div {
  text-align: left;
}

.ivu-modal {
  margin: auto;
}

.demo-drawer-footer {
  /**侧边推拉*/
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

/* 强制设置 菜单宽度为自适应 */
#alarmCenter .labels .ivu-menu-vertical {
  width: 100% !important;
}

.ivu-page {
  text-align: center;
}

.labelsD {
  padding-bottom: 15px;
  font-size: 14px;
  border: 1px solid #ccc;
  margin: 2%;
  overflow: auto;
  height: 500px;
  border-radius: 15px;
}

.labelsD b {
  width: 80px;
  display: inline-block;
  font-weight: normal;
  text-align: right;
}

/* 设置滚动条宽度 */
.labelsD::-webkit-scrollbar {
  width: 0px;
}

.labelsD::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}

.formList {
  height: 20%;
  border-bottom: 1px solid #82c1fc;
}

.formLists {
  width: 86%;
  height: 94%;
  margin-left: 13%;
  padding-top: 5px;
  border: 2px solid #82c1fc;
}

.tableStyle {
  width: 100%;
  height: 80%;
}

.labels {
  width: 100%;
  height: 100%;
  border: 0px solid #82c1fc;
}

.buttonStyle {
  position: absolute;
  bottom: 1%;
}

.button {
  position: absolute;
  left: 177%;
  top: 50%;
  width: 20%;
  height: 40%;
  z-index: 1;
  background: #ccc;
  border: 3px solid #2db7f5;
  border-radius: 2%;
}

.button button {
  width: 17%;
  height: 15%;
  margin: 2px;
  font-size: 16px;
  padding: 0px;
}

.formList span {
  /*width: 100px;*/
  display: block;
  float: left;
  height: 32px;
  line-height: 32px;
}

.formList b {
  width: 5%;
  display: inline-table;
  height: 32px;
  line-height: 32px;
  font-weight: normal;
  text-align: right;
  min-width: 60px;
}

.ivu-menu-vertical.ivu-menu-light:after {
  background: #fff;
}

.ruleStyle {
  padding-top: 15px;
}

/* .ruleStyle .buttonStyl button{
        padding: 5px 10px 6px;
    } */
#alarmCenter .bulrColor input {
  border-color: #ed4014 !important;
}

.buttonList Button {
  float: left;
  margin: 1px;
}

.buttonList div {
  float: left;
  margin: 1px;
}

#alarmCenter .ivu-table-overflowX {
  overflow-x: hidden !important;
}

#alarmCenter .ivu-table-overflowY {
  overflow-y: hidden !important;
}

#drawer .ivu-table-overflowY {
  overflow-y: auto !important;
}

#alarmCenter .ivu-spin-fix {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/alarmCenter.vue